//import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Locale } from 'date-fns';
import { StorageService } from '../storage-service.service';
import { it, enUS, fr, nl, de } from 'date-fns/locale';

@Injectable({ providedIn: 'root' })
export class LangProvider {


  nessunCaneAmmesso_EN = "No dogs allowed";
  nessunCaneAmmesso_IT = "Nessun cane ammesso";
  nessunCaneAmmesso_FR = "Aucun chien autorisé";
  nessunCaneAmmesso_NL = "Geen honden toegestaan";
  nessunCaneAmmesso_DE = "Keine Hunde erlaubt";
  capienzaInfoHeader_IT = "In questa postazione possono starci";
  capienzaInfoHeader_EN = "In this place can be";
  capienzaInfoHeader_FR = "Dans cette salle peuvent se trouver";
  capienzaInfoHeader_NL = "Op deze plaats kunnen zijn";
  capienzaInfoHeader_DE = "In diesem Bereich sind möglich";

  cani_EN = "dogs";
  cani_IT = "cani";
  cani_FR = "chiens";
  cani_NL = "honden";
  cani_DE = "Hunde";
  cane_EN = "dog";
  cane_IT = "cane";
  cane_FR = "chien";
  cane_NL = "hond";
  cane_DE = "Hund";

  caneGrande_EN = "Large";
  caneGrande_IT = "Grande";
  caneGrande_FR = "Grand";
  caneGrande_NL = "Groot";
  caneGrande_DE = "Groß";

  caniGrandi_EN = "Large";
  caniGrandi_IT = "Grandi";
  caniGrandi_FR = "Grand";
  caniGrandi_NL = "Groot";
  caniGrandi_DE = "Groß";

  erroreCalcoloPrezzo_IT = 'Non è stato possibile calcolare il prezzo. Riprova più tardi.';
  erroreCalcoloPrezzo_EN = 'Unable to calculate the price. Please try again later.';
  erroreCalcoloPrezzo_FR = 'Impossible de calculer le prix. Veuillez essayer plus tard.';
  erroreCalcoloPrezzo_NL = 'Kan de prijs niet berekenen. Probeer het later opnieuw.';
  erroreCalcoloPrezzo_DE = 'Der Preis konnte nicht berechnet werden. Bitte versuchen Sie es später erneut.';

  canePiccolo_EN = "Small";
  canePiccolo_IT = "Piccolo";
  canePiccolo_FR = "Petit";
  canePiccolo_NL = "Klein";
  canePiccolo_DE = "Klein";

  caniPiccoli_EN = "Small";
  caniPiccoli_IT = "Piccoli";
  caniPiccoli_FR = "Petit";
  caniPiccoli_NL = "Klein";
  caniPiccoli_DE = "Klein";

  // Traduzioni per le regole di capienza cani
  puoOspitare_IT = "Può ospitare";
  puoOspitare_EN = "Can host";
  puoOspitare_FR = "Peut accueillir";
  puoOspitare_NL = "Kan ontvangen";
  puoOspitare_DE = "Kann aufnehmen";

  caneDi_IT = "cane di";
  caneDi_EN = "dog of";
  caneDi_FR = "chien de";
  caneDi_NL = "hond van";
  caneDi_DE = "Hund der";

  caniDi_IT = "cani di";
  caniDi_EN = "dogs of";
  caniDi_FR = "chiens de";
  caniDi_NL = "honden van";
  caniDi_DE = "Hunde der";

  tagliaPiccola_IT = "taglia piccola";
  tagliaPiccola_EN = "small size";
  tagliaPiccola_FR = "petite taille";
  tagliaPiccola_NL = "kleine maat";
  tagliaPiccola_DE = "kleine Größe";

  tagliaGrande_IT = "taglia grande";
  tagliaGrande_EN = "large size";
  tagliaGrande_FR = "grande taille";
  tagliaGrande_NL = "grote maat";
  tagliaGrande_DE = "große Größe";

  diversaTaglia_IT = "diversa taglia";
  diversaTaglia_EN = "mixed sizes";
  diversaTaglia_FR = "tailles différentes";
  diversaTaglia_NL = "verschillende maten";
  diversaTaglia_DE = "gemischte Größen";

  ombrelloniCaniGrandi_EN = "Large Dog Umbrellas";
  ombrelloniCaniGrandi_IT = "Ombrelloni Cani Grandi";
  ombrelloniCaniGrandi_FR = "Parasols pour Grands Chiens";
  ombrelloniCaniGrandi_DE = "Sonnenschirme für große Hunde";

  ombrelloniCaniGrandiDesc_EN = "First row: max 4 people, 1 dog\n";
  ombrelloniCaniGrandiDesc_DE = "Erste Reihe: max. 4 Personen, 1 Hund\n";
  ombrelloniCaniGrandiOtherRowsDesc_EN = "Other Rows: max 2 people, 1 dog";
  ombrelloniCaniGrandiOtherRowsDesc_DE = "Andere Reihen: max. 2 Personen, 1 Hund";
  ombrelloniCaniGrandiDesc_IT = "Prima fila: max 4 persone 1 cane\n";
  ombrelloniCaniGrandiOtherRowsDesc_IT = "Altre file: max 2 persone 1 cane";
  ombrelloniCaniGrandiDesc_FR = "Première rangée : max 4 personnes, 1 chien\n";
  ombrelloniCaniGrandiOtherRowsDesc_FR = "Autre rangée: max 2 personnes, 1 chien";

  ombrelloniCaniPiccoli_EN = "Small Dog Umbrellas";
  ombrelloniCaniPiccoli_IT = "Ombrelloni Cani Piccoli";
  ombrelloniCaniPiccoli_FR = "Parasols pour Petits Chiens";
  ombrelloniCaniPiccoli_DE = "Sonnenschirme für kleine Hunde";

  ombrelloniCaniPiccoliDesc_EN = "First row: max 4 people, 2 dogs\nR ";
  ombrelloniCaniPiccoliDesc_DE = "Erste Reihe: max. 4 Personen, 2 Hunde\n";
  ombrelloniCaniPiccoliOtherRowsDesc_EN = "Other rows: max 2 people, 2 dogs";
  ombrelloniCaniPiccoliOtherRowsDesc_DE = "Andere Reihen: max. 2 Personen, 2 Hunde";
  ombrelloniCaniPiccoliDesc_IT = "Prima fila: max 4 persone, 2 cani\n";
  ombrelloniCaniPiccoliOtherRowsDesc_IT = "Altre file: max 2 persone, 2 cani";
  ombrelloniCaniPiccoliDesc_FR = "Première rangée: max 4 personnes, 2 chiens\n ";
  ombrelloniCaniPiccoliOtherRowsDesc_FR = "Autre rangées: max 2 personnes, 2 chiens";

  gazeboCani_EN = "Dog Gazebo";
  gazeboCani_IT = "Gazebo Cani";
  gazeboCani_FR = "Gazebo pour Chiens";
  gazeboCani_DE = "Hundegazebo";

  gazeboCaniDesc_EN = "Max 6 people and 3 dogs of any size";
  gazeboCaniDesc_IT = "Max 6 persone e 3 cani anche di diversa taglia";
  gazeboCaniDesc_FR = "Max 6 personnes et 3 chiens de toute taille";
  gazeboCaniDesc_DE = "Max. 6 Personen und 3 Hunde jeder Größe";

  // Traduzioni per le labels delle aree
  dogsGazeboes_IT = "GAZEBO";
  dogsGazeboes_EN = "GAZEBOES";
  dogsGazeboes_FR = "GAZEBOS";
  dogsGazeboes_NL = "GAZEBOS";
  dogsGazeboes_DE = "GAZEBOS";

  businessClassGazeboes_IT = "GAZEBO BUSINESS CLASS";
  businessClassGazeboes_EN = "BUSINESS CLASS GAZEBOES";
  businessClassGazeboes_FR = "GAZEBOS BUSINESS CLASS";
  businessClassGazeboes_NL = "BUSINESS CLASS GAZEBO'S";
  businessClassGazeboes_DE = "BUSINESS-CLASS-GAZEBOS";

  dogsGazeboesCapacity_IT = "MAX 6 👤👤👤👤👤👤 / 3 🐶🐶🐶";
  dogsGazeboesCapacity_EN = "MAX 6 👤👤👤👤👤👤  / 3 🐶🐶🐶";
  dogsGazeboesCapacity_FR = "MAX 6 👤👤👤👤👤👤  / 3 🐶🐶🐶";
  dogsGazeboesCapacity_NL = "MAX 6 👤👤👤👤👤👤  / 3 🐶🐶🐶";
  dogsGazeboesCapacity_DE = "MAX 6 👤👤👤👤👤👤 . / 3 🐶🐶🐶";

  businessClassGazeboesCapacity_IT = "MAX 6 👤👤👤👤👤👤 / 3 🐶🐶🐶";
  businessClassGazeboesCapacity_EN = "MAX 6 👤👤👤👤👤👤 / 3 🐶🐶🐶";
  businessClassGazeboesCapacity_FR = "MAX 6 👤👤👤👤👤👤 / 3 🐶🐶🐶";
  businessClassGazeboesCapacity_NL = "MAX 6 👤👤👤👤👤👤 / 3 🐶🐶🐶";
  businessClassGazeboesCapacity_DE = "MAX 6 👤👤👤👤👤👤 / 3 🐶🐶🐶";

  businessClassExclusiveSetup_IT = "Allestimento Business Class";
  businessClassExclusiveSetup_EN = "Business Class Setup";
  businessClassExclusiveSetup_FR = "Equipement Business Class";
  businessClassExclusiveSetup_NL = "Business Class Inrichting";
  businessClassExclusiveSetup_DE = "Business-Class-Ausstattung";

  businessClassSetupTitle_IT = "Allestimento Gazebo Business Class";
  businessClassSetupTitle_EN = "Business Class Gazebo Setup";
  businessClassSetupTitle_FR = "Equipement Gazebo Business Class";
  businessClassSetupTitle_NL = "Business Class Gazebo Inrichting";
  businessClassSetupTitle_DE = "Business-Class-Gazebo Ausstattung";

  businessClassSetupSubtitle_IT = "Dotazioni esclusive incluse nella prenotazione:";
  businessClassSetupSubtitle_EN = "Exclusive equipment included in your booking:";
  businessClassSetupSubtitle_FR = "Equipements exclusifs inclus dans la reservation:";
  businessClassSetupSubtitle_NL = "Exclusieve voorzieningen inbegrepen in de boeking:";
  businessClassSetupSubtitle_DE = "Exklusive Ausstattung in der Buchung enthalten:";

  businessClassSectionRelaxTitle_IT = "Area Relax Persone";
  businessClassSectionRelaxTitle_EN = "People Relax Area";
  businessClassSectionRelaxTitle_FR = "Espace Relax Personnes";
  businessClassSectionRelaxTitle_NL = "Relaxzone Personen";
  businessClassSectionRelaxTitle_DE = "Relaxbereich Personen";

  businessClassSectionDogTitle_IT = "Area Comfort Cane";
  businessClassSectionDogTitle_EN = "Dog Comfort Area";
  businessClassSectionDogTitle_FR = "Espace Confort Chien";
  businessClassSectionDogTitle_NL = "Comfortzone Hond";
  businessClassSectionDogTitle_DE = "Komfortbereich Hund";

  businessClassSectionAccessoriesTitle_IT = "Accessori Business Class";
  businessClassSectionAccessoriesTitle_EN = "Business Class Accessories";
  businessClassSectionAccessoriesTitle_FR = "Accessoires Business Class";
  businessClassSectionAccessoriesTitle_NL = "Business Class Accessoires";
  businessClassSectionAccessoriesTitle_DE = "Business-Class-Zubehoer";

  businessClassSectionWelcomeTitle_IT = "Box di Benvenuto";
  businessClassSectionWelcomeTitle_EN = "Welcome Box";
  businessClassSectionWelcomeTitle_FR = "Box de Bienvenue";
  businessClassSectionWelcomeTitle_NL = "Welkomstbox";
  businessClassSectionWelcomeTitle_DE = "Willkommensbox";

  businessClassRelaxItem1_IT = "2 lettini prendisole fronte mare con materasso";
  businessClassRelaxItem1_EN = "2 seafront sunbeds with mattress";
  businessClassRelaxItem1_FR = "2 transats face mer avec matelas";
  businessClassRelaxItem1_NL = "2 ligbedden aan zee met matras";
  businessClassRelaxItem1_DE = "2 Sonnenliegen am Meer mit Matratze";

  businessClassRelaxItem2_IT = "2 sdraio reclinabili con cuscino";
  businessClassRelaxItem2_EN = "2 reclining deck chairs with cushion";
  businessClassRelaxItem2_FR = "2 chiliennes inclinables avec coussin";
  businessClassRelaxItem2_NL = "2 verstelbare strandstoelen met kussen";
  businessClassRelaxItem2_DE = "2 verstellbare Liegestuehle mit Kissen";

  businessClassRelaxItem3_IT = "1 sedia regista";
  businessClassRelaxItem3_EN = "1 director chair";
  businessClassRelaxItem3_FR = "1 chaise realisateur";
  businessClassRelaxItem3_NL = "1 regisseursstoel";
  businessClassRelaxItem3_DE = "1 Regiestuhl";

  businessClassRelaxItem4_IT = "1 tavolo basso";
  businessClassRelaxItem4_EN = "1 low table";
  businessClassRelaxItem4_FR = "1 table basse";
  businessClassRelaxItem4_NL = "1 lage tafel";
  businessClassRelaxItem4_DE = "1 niedriger Tisch";

  businessClassRelaxItem5_IT = "1 tavolo pieghevole in legno";
  businessClassRelaxItem5_EN = "1 foldable wooden table";
  businessClassRelaxItem5_FR = "1 table pliante en bois";
  businessClassRelaxItem5_NL = "1 opvouwbare houten tafel";
  businessClassRelaxItem5_DE = "1 klappbarer Holztisch";

  businessClassRelaxItem6_IT = "1 mobiletto porta oggetti";
  businessClassRelaxItem6_EN = "1 storage cabinet";
  businessClassRelaxItem6_FR = "1 meuble de rangement";
  businessClassRelaxItem6_NL = "1 opbergkastje";
  businessClassRelaxItem6_DE = "1 Aufbewahrungsschraenkchen";

  businessClassRelaxItem7_IT = "1 amaca sospesa";
  businessClassRelaxItem7_EN = "1 hanging hammock";
  businessClassRelaxItem7_FR = "1 hamac suspendu";
  businessClassRelaxItem7_NL = "1 hangmat";
  businessClassRelaxItem7_DE = "1 Haengematte";

  businessClassDogItem1_IT = "1 lettino rialzato con materassino rinfrescante";
  businessClassDogItem1_EN = "1 raised dog bed with cooling mat";
  businessClassDogItem1_FR = "1 lit sureleve avec matelas rafraichissant";
  businessClassDogItem1_NL = "1 verhoogd hondenbed met verkoelend matje";
  businessClassDogItem1_DE = "1 erhoehtes Hundebett mit kuehlender Matte";

  businessClassDogItem2_IT = "1 ciotola in acciaio";
  businessClassDogItem2_EN = "1 stainless steel bowl";
  businessClassDogItem2_FR = "1 gamelle en acier inoxydable";
  businessClassDogItem2_NL = "1 roestvrijstalen voerbak";
  businessClassDogItem2_DE = "1 Edelstahlnapf";

  businessClassDogItem3_IT = "Area ombreggiata dedicata";
  businessClassDogItem3_EN = "Dedicated shaded area";
  businessClassDogItem3_FR = "Zone ombragee dediee";
  businessClassDogItem3_NL = "Aparte schaduwzone";
  businessClassDogItem3_DE = "Separater Schattenbereich";

  businessClassAccessoriesItem1_IT = "Braccetto porta tablet";
  businessClassAccessoriesItem1_EN = "Tablet support arm";
  businessClassAccessoriesItem1_FR = "Support tablette articule";
  businessClassAccessoriesItem1_NL = "Tabletarm";
  businessClassAccessoriesItem1_DE = "Tablet-Halterarm";

  businessClassAccessoriesItem2_IT = "Cassetta con chiave (uso mini cassaforte)";
  businessClassAccessoriesItem2_EN = "Lockable box (mini safe use)";
  businessClassAccessoriesItem2_FR = "Boite avec cle (usage mini coffre-fort)";
  businessClassAccessoriesItem2_NL = "Kist met sleutel (mini-kluis)";
  businessClassAccessoriesItem2_DE = "Abschliessbare Box (Mini-Safe)";

  businessClassAccessoriesItem3_IT = "Appendiabiti in legno";
  businessClassAccessoriesItem3_EN = "Wooden coat rack";
  businessClassAccessoriesItem3_FR = "Porte-manteau en bois";
  businessClassAccessoriesItem3_NL = "Houten kapstok";
  businessClassAccessoriesItem3_DE = "Holzkleiderstaender";

  businessClassAccessoriesItem4_IT = "Punto luce centrale";
  businessClassAccessoriesItem4_EN = "Central light point";
  businessClassAccessoriesItem4_FR = "Point lumineux central";
  businessClassAccessoriesItem4_NL = "Centraal lichtpunt";
  businessClassAccessoriesItem4_DE = "Zentraler Lichtpunkt";

  businessClassAccessoriesItem5_IT = "Presa corrente con USB e USB-C";
  businessClassAccessoriesItem5_EN = "Power outlet with USB and USB-C";
  businessClassAccessoriesItem5_FR = "Prise electrique avec USB et USB-C";
  businessClassAccessoriesItem5_NL = "Stopcontact met USB en USB-C";
  businessClassAccessoriesItem5_DE = "Steckdose mit USB und USB-C";

  businessClassWelcomeItem1_IT = "Protezione solare SPF 50";
  businessClassWelcomeItem1_EN = "Sunscreen SPF 50";
  businessClassWelcomeItem1_FR = "Protection solaire SPF 50";
  businessClassWelcomeItem1_NL = "Zonnebescherming SPF 50";
  businessClassWelcomeItem1_DE = "Sonnenschutz SPF 50";

  businessClassWelcomeItem2_IT = "Doposole";
  businessClassWelcomeItem2_EN = "After-sun lotion";
  businessClassWelcomeItem2_FR = "Apres-soleil";
  businessClassWelcomeItem2_NL = "After-sun";
  businessClassWelcomeItem2_DE = "After-Sun";

  businessClassWelcomeItem3_IT = "Doccia schiuma";
  businessClassWelcomeItem3_EN = "Shower gel";
  businessClassWelcomeItem3_FR = "Gel douche";
  businessClassWelcomeItem3_NL = "Douchegel";
  businessClassWelcomeItem3_DE = "Duschgel";

  businessClassWelcomeItem4_IT = "Shampoo bio per cani";
  businessClassWelcomeItem4_EN = "Organic dog shampoo";
  businessClassWelcomeItem4_FR = "Shampooing bio pour chiens";
  businessClassWelcomeItem4_NL = "Biologische hondenshampoo";
  businessClassWelcomeItem4_DE = "Bio-Shampoo fuer Hunde";

  businessClassWelcomeItem5_IT = "Asciugamano monouso cane";
  businessClassWelcomeItem5_EN = "Disposable dog towel";
  businessClassWelcomeItem5_FR = "Serviette jetable pour chien";
  businessClassWelcomeItem5_NL = "Wegwerphanddoek voor hond";
  businessClassWelcomeItem5_DE = "Einweg-Handtuch fuer den Hund";

  businessClassWelcomeItem6_IT = "Snack e biscotti per cani";
  businessClassWelcomeItem6_EN = "Dog snacks and biscuits";
  businessClassWelcomeItem6_FR = "Snacks et biscuits pour chiens";
  businessClassWelcomeItem6_NL = "Snacks en hondenkoekjes";
  businessClassWelcomeItem6_DE = "Snacks und Hundekekse";

  bigDogs_IT = "CANI GRANDI";
  bigDogs_EN = "BIG DOGS";
  bigDogs_FR = "GRANDS CHIENS";
  bigDogs_NL = "GROTE HONDEN";
  bigDogs_DE = "GROSSE HUNDE";

  bigDogsCapacity_IT = "MAX 1 🐶";
  bigDogsCapacity_EN = "MAX 1 🐶";
  bigDogsCapacity_FR = "MAX 1 🐶";
  bigDogsCapacity_NL = "MAX 1 🐶";
  bigDogsCapacity_DE = "MAX 1 🐶";

  smallDogs_IT = "CANI PICCOLI";
  smallDogs_EN = "SMALL DOGS";
  smallDogs_FR = "PETITS CHIENS";
  smallDogs_NL = "KLEINE HONDEN";
  smallDogs_DE = "KLEINE HUNDE";

  smallDogsCapacity_IT = "MAX 2 🐶🐶";
  smallDogsCapacity_EN = "MAX 2 🐶🐶";
  smallDogsCapacity_FR = "MAX 2 🐶🐶";
  smallDogsCapacity_NL = "MAX 2 🐶🐶";
  smallDogsCapacity_DE = "MAX 2 🐶🐶";

  rowCapacityFirst_IT = "MAX 4 👤👤👤👤";
  rowCapacityFirst_EN = "MAX 4 👤👤👤👤";
  rowCapacityFirst_FR = "MAX 4 👤👤👤👤";
  rowCapacityFirst_NL = "MAX 4 👤👤👤👤";
  rowCapacityFirst_DE = "MAX 4 👤👤👤👤.";

  rowCapacitySecondThird_IT = "MAX 3 👤👤👤";
  rowCapacitySecondThird_EN = "MAX 3 👤👤👤";
  rowCapacitySecondThird_FR = "MAX 3 👤👤👤";
  rowCapacitySecondThird_NL = "MAX 3 👤👤👤";
  rowCapacitySecondThird_DE = "MAX 3 👤👤👤.";

  rowCapacityFourthFifthSixth_IT = "MAX 2 👤👤";
  rowCapacityFourthFifthSixth_EN = "MAX 2 👤👤";
  rowCapacityFourthFifthSixth_FR = "MAX 2 👤👤";
  rowCapacityFourthFifthSixth_NL = "MAX 2 👤👤";
  rowCapacityFourthFifthSixth_DE = "MAX 2 👤👤.";

  facilityCoffee_IT = "CAFFE";
  facilityCoffee_EN = "COFFEE";
  facilityCoffee_FR = "CAFE";
  facilityCoffee_NL = "KOFFIE";
  facilityCoffee_DE = "KAFFEE";

  facilityBar_IT = "BAR";
  facilityBar_EN = "BAR";
  facilityBar_FR = "BAR";
  facilityBar_NL = "BAR";
  facilityBar_DE = "BAR";

  facilityKitchen_IT = "CUCINA";
  facilityKitchen_EN = "KITCHEN";
  facilityKitchen_FR = "CUISINE";
  facilityKitchen_NL = "KEUKEN";
  facilityKitchen_DE = "KUECHE";

  facilityOffice_IT = "UFFICIO";
  facilityOffice_EN = "OFFICE";
  facilityOffice_FR = "BUREAU";
  facilityOffice_NL = "KANTOOR";
  facilityOffice_DE = "BUERO";

  facilityWarehouse_IT = "MAGAZZINO";
  facilityWarehouse_EN = "WAREHOUSE";
  facilityWarehouse_FR = "ENTREPOT";
  facilityWarehouse_NL = "MAGAZIJN";
  facilityWarehouse_DE = "LAGER";

  facilityWcAnd_IT = "W.C. E";
  facilityWcAnd_EN = "W.C. AND";
  facilityWcAnd_FR = "W.C. ET";
  facilityWcAnd_NL = "W.C. EN";
  facilityWcAnd_DE = "W.C. UND";

  facilityHotShower_IT = "DOCCIA CALDA";
  facilityHotShower_EN = "HOT SHOWER";
  facilityHotShower_FR = "DOUCHE CHAUDE";
  facilityHotShower_NL = "WARME DOUCHE";
  facilityHotShower_DE = "WARME DUSCHE";

  facilityStorage_IT = "DEPOSITO";
  facilityStorage_EN = "STORAGE";
  facilityStorage_FR = "STOCKAGE";
  facilityStorage_NL = "OPSLAG";
  facilityStorage_DE = "LAGERUNG";

  facilityBeachEntrance_IT = "INGRESSO SPIAGGIA";
  facilityBeachEntrance_EN = "BEACH ENTRANCE";
  facilityBeachEntrance_FR = "ENTREE PLAGE";
  facilityBeachEntrance_NL = "STRANDINGANG";
  facilityBeachEntrance_DE = "STRANDEINGANG";

  lifeguardTowerLineOne_IT = "TORRETTA";
  lifeguardTowerLineOne_EN = "LIFEGUARD";
  lifeguardTowerLineOne_FR = "TOUR";
  lifeguardTowerLineOne_NL = "REDDER";
  lifeguardTowerLineOne_DE = "RETTUNGS";

  lifeguardTowerLineTwo_IT = "BAGNINO";
  lifeguardTowerLineTwo_EN = "TOWER";
  lifeguardTowerLineTwo_FR = "SAUVETAGE";
  lifeguardTowerLineTwo_NL = "TOREN";
  lifeguardTowerLineTwo_DE = "TURM";

  // Traduzioni per il popover informativo capienza
  capienzaInfoTitle_IT = "Precisazione per la capienza massima delle postazioni";
  capienzaInfoTitle_EN = "Maximum capacity specifications";
  capienzaInfoTitle_FR = "Précisions sur la capacité maximale des postes";
  capienzaInfoTitle_NL = "Maximale capaciteitsspecificaties";
  capienzaInfoTitle_DE = "Hinweise zur maximalen Kapazität";

  capienzaPrimaFila_IT = "Ombrelloni prima fila: max 4 persone e 1 cane (ombrelloni cani grandi) o 2 cani (ombrelloni cani piccoli)";
  capienzaPrimaFila_EN = "First row umbrellas: max 4 people and 1 dog (large dog umbrellas) or 2 dogs (small dog umbrellas)";
  capienzaPrimaFila_FR = "Parasols première rangée: max 4 personnes et 1 chien (parasols grands chiens) ou 2 chiens (parasols petits chiens)";
  capienzaPrimaFila_NL = "Parasols eerste rij: max 4 personen en 1 hond (grote honden parasols) of 2 honden (kleine honden parasols)";
  capienzaPrimaFila_DE = "Sonnenschirme 1. Reihe: max. 4 Personen und 1 Hund (große Hunde) oder 2 Hunde (kleine Hunde)";

  capienzaSecondaTerzaFila_IT = "Ombrelloni seconda e terza fila: max 3 persone e 1 cane (ombrelloni cani grandi) o 2 cani (ombrelloni cani piccoli)";
  capienzaSecondaTerzaFila_EN = "Second and third row umbrellas: max 3 people and 1 dog (large dog umbrellas) or 2 dogs (small dog umbrellas)";
  capienzaSecondaTerzaFila_FR = "Parasols deuxième et troisième rangée: max 3 personnes et 1 chien (parasols grands chiens) ou 2 chiens (parasols petits chiens)";
  capienzaSecondaTerzaFila_NL = "Parasols tweede en derde rij: max 3 personen en 1 hond (grote honden parasols) of 2 honden (kleine honden parasols)";
  capienzaSecondaTerzaFila_DE = "Sonnenschirme 2. und 3. Reihe: max. 3 Personen und 1 Hund (große Hunde) oder 2 Hunde (kleine Hunde)";

  capienzaQuartaQuintaSestaFila_IT = "Ombrelloni quarta, quinta e sesta fila: max 2 persone e 1 cane (ombrelloni cani grandi) o 2 cani (ombrelloni cani piccoli)";
  capienzaQuartaQuintaSestaFila_EN = "Fourth, fifth and sixth row umbrellas: max 2 people and 1 dog (large dog umbrellas) or 2 dogs (small dog umbrellas)";
  capienzaQuartaQuintaSestaFila_FR = "Parasols quatrième, cinquième et sixième rangée: max 2 personnes et 1 chien (parasols grands chiens) ou 2 chiens (parasols petits chiens)";
  capienzaQuartaQuintaSestaFila_NL = "Parasols vierde, vijfde en zesde rij: max 2 personen en 1 hond (grote honden parasols) of 2 honden (kleine honden parasols)";
  capienzaQuartaQuintaSestaFila_DE = "Sonnenschirme 4., 5. und 6. Reihe: max. 2 Personen und 1 Hund (große Hunde) oder 2 Hunde (kleine Hunde)";

  capienzaGazebo_IT = "Gazebo: max 6 persone e 3 cani anche di diversa taglia";
  capienzaGazebo_EN = "Gazebo: max 6 people and 3 dogs of any size";
  capienzaGazebo_FR = "Gazebo: max 6 personnes et 3 chiens de toute taille";
  capienzaGazebo_NL = "Gazebo: max 6 personen en 3 honden van elke maat";
  capienzaGazebo_DE = "Gazebo: max. 6 Personen und 3 Hunde jeder Größe";

  // Traduzioni per politica di prenotazione e condizioni meteo
  politicaModificaTitle_IT = "Politica di Prenotazione e Condizioni Meteo";
  politicaModificaTitle_EN = "Booking Policy and Weather Conditions";
  politicaModificaTitle_FR = "Politique de Réservation et Conditions Météorologiques";
  politicaModificaTitle_NL = "Boekingsbeleid en Weersomstandigheden";
  politicaModificaTitle_DE = "Buchungsrichtlinie und Wetterbedingungen";

  politicaModificaParagraph1_IT = "Le prenotazioni confermate con pagamento immediato sono definitive e non rimborsabili, salvo il caso di chiusura totale dello stabilimento per provvedimento dell’autorità competente.";
  politicaModificaParagraph1_EN = "Reservations confirmed with immediate payment are final and non-refundable, except in the event of a full closure of the beach club by order of the competent authority.";
  politicaModificaParagraph1_FR = "Les réservations confirmées avec paiement immédiat sont définitives et non remboursables, sauf en cas de fermeture totale de l’établissement par décision de l’autorité compétente.";
  politicaModificaParagraph1_NL = "Reserveringen die met onmiddellijke betaling zijn bevestigd, zijn definitief en niet-restitueerbaar, behalve in geval van volledige sluiting van het strandbedrijf op last van de bevoegde autoriteit.";
  politicaModificaParagraph1_DE = "Reservierungen, die mit sofortiger Zahlung bestätigt werden, sind verbindlich und nicht erstattungsfähig, außer im Fall einer vollständigen Schließung der Anlage auf Anordnung der zuständigen Behörde.";

  politicaModificaParagraph2_IT = "Non sono previsti rimborsi in caso di mancato utilizzo del servizio per scelta dell’utente, condizioni meteorologiche variabili, mare mosso, vento, pioggia, o temporanea indisponibilità di servizi accessori, qualora la struttura risulti regolarmente aperta e operativa.";
  politicaModificaParagraph2_EN = "No refunds will be issued in the event of non-use of the service due to the user's choice, variable weather conditions, rough sea, wind, rain, or temporary unavailability of ancillary services, provided that the venue remains regularly open and operational.";
  politicaModificaParagraph2_FR = "Aucun remboursement n’est prévu en cas de non-utilisation du service du fait du choix de l’utilisateur, de conditions météorologiques variables, de mer agitée, de vent, de pluie ou d’indisponibilité temporaire de services accessoires, dès lors que la structure est régulièrement ouverte et opérationnelle.";
  politicaModificaParagraph2_NL = "Er wordt geen restitutie verleend wanneer de dienst niet wordt gebruikt door keuze van de gebruiker, wisselende weersomstandigheden, ruwe zee, wind, regen of tijdelijke onbeschikbaarheid van aanvullende diensten, zolang de locatie regulier open en operationeel is.";
  politicaModificaParagraph2_DE = "Es werden keine Rückerstattungen gewährt, wenn die Leistung aufgrund der Entscheidung des Nutzers, wechselhafter Wetterbedingungen, rauer See, Wind, Regen oder einer vorübergehenden Nichtverfügbarkeit von Zusatzleistungen nicht genutzt wird, sofern die Anlage regulär geöffnet und betriebsbereit ist.";

  politicaModificaParagraph3_IT = "In caso di chiusura totale dello stabilimento per cause straordinarie o provvedimento dell’autorità, la struttura potrà offrire lo spostamento della prenotazione ad altra data nella stessa stagione o un voucher di pari importo. Il rimborso potrà essere riconosciuto esclusivamente in caso di comprovata impossibilità oggettiva dell’utente di usufruire delle soluzioni alternative proposte.";
  politicaModificaParagraph3_EN = "In the event of a full closure of the beach club due to extraordinary causes or by order of the authority, the venue may offer to move the reservation to another date within the same season or issue a voucher of equal value. A refund may be granted exclusively in the event of a documented objective impossibility for the user to make use of the proposed alternative solutions.";
  politicaModificaParagraph3_FR = "En cas de fermeture totale de l’établissement pour causes extraordinaires ou sur décision de l’autorité, la structure pourra proposer le report de la réservation à une autre date de la même saison ou un bon d’une valeur équivalente. Le remboursement pourra être reconnu exclusivement en cas d’impossibilité objective avérée pour l’utilisateur de bénéficier des solutions alternatives proposées.";
  politicaModificaParagraph3_NL = "In geval van volledige sluiting van het strandbedrijf door buitengewone oorzaken of op last van de autoriteit kan de locatie aanbieden de reservering te verplaatsen naar een andere datum binnen hetzelfde seizoen of een voucher met gelijke waarde te verstrekken. Een restitutie kan uitsluitend worden toegekend als objectief en aantoonbaar onmogelijk is voor de gebruiker om gebruik te maken van de voorgestelde alternatieve oplossingen.";
  politicaModificaParagraph3_DE = "Im Fall einer vollständigen Schließung der Anlage aus außergewöhnlichen Gründen oder auf Anordnung der Behörde kann die Anlage eine Verlegung der Reservierung auf ein anderes Datum innerhalb derselben Saison oder einen Gutschein in gleicher Höhe anbieten. Eine Rückerstattung kann ausschließlich dann gewährt werden, wenn der Nutzer die vorgeschlagenen Alternativen nachweislich aus objektiven Gründen nicht in Anspruch nehmen kann.";

  politicaModificaParagraph4_IT = "La modalità “paga dopo” non costituisce riserva definitiva fino al pagamento, può essere cancellata dall’utente finché in attesa di saldo ed è annullata automaticamente in caso di mancato pagamento entro 24 ore dalla data prenotata. È disponibile solo per prenotazioni effettuate con anticipo superiore a 24 ore; le prenotazioni per il giorno stesso richiedono pagamento immediato.";
  politicaModificaParagraph4_EN = "The “pay later” option does not constitute a final reservation until payment is made, may be cancelled by the user while awaiting settlement, and is automatically cancelled if payment is not made at least 24 hours before the booked date. It is available only for reservations made more than 24 hours in advance; same-day reservations require immediate payment.";
  politicaModificaParagraph4_FR = "Le mode « payer plus tard » ne constitue pas une réservation définitive tant que le paiement n’a pas été effectué, peut être annulé par l’utilisateur tant qu’il reste en attente de règlement et est annulé automatiquement si le paiement n’est pas effectué au moins 24 heures avant la date réservée. Il n’est disponible que pour les réservations effectuées plus de 24 heures à l’avance ; les réservations pour le jour même exigent un paiement immédiat.";
  politicaModificaParagraph4_NL = "De optie ‘betaal later’ vormt geen definitieve reservering totdat de betaling is voldaan, kan door de gebruiker worden geannuleerd zolang de betaling nog openstaat en wordt automatisch geannuleerd als niet uiterlijk 24 uur voor de gereserveerde datum is betaald. Deze optie is alleen beschikbaar voor reserveringen die meer dan 24 uur van tevoren worden gemaakt; reserveringen voor dezelfde dag vereisen onmiddellijke betaling.";
  politicaModificaParagraph4_DE = "Die Option „später bezahlen“ stellt bis zur erfolgten Zahlung keine verbindliche Reservierung dar, kann vom Nutzer storniert werden, solange sie noch offen ist, und wird automatisch storniert, wenn die Zahlung nicht spätestens 24 Stunden vor dem gebuchten Datum erfolgt. Sie ist nur für Reservierungen verfügbar, die mehr als 24 Stunden im Voraus vorgenommen werden; Reservierungen für denselben Tag erfordern eine sofortige Zahlung.";

  politicaModificaParagraph5_IT = "Per prenotazioni effettuate con largo anticipo si consiglia l’utilizzo della modalità “paga dopo”, così da poter verificare con maggiore attendibilità le condizioni prima di procedere al pagamento.";
  politicaModificaParagraph5_EN = "For reservations made well in advance, use of the “pay later” option is recommended so that conditions can be checked more reliably before proceeding with payment.";
  politicaModificaParagraph5_FR = "Pour les réservations effectuées longtemps à l’avance, il est conseillé d’utiliser le mode « payer plus tard », afin de pouvoir vérifier les conditions avec davantage de fiabilité avant de procéder au paiement.";
  politicaModificaParagraph5_NL = "Voor reserveringen die ruim van tevoren worden gemaakt, wordt aangeraden de optie ‘betaal later’ te gebruiken, zodat de omstandigheden betrouwbaarder kunnen worden gecontroleerd voordat tot betaling wordt overgegaan.";
  politicaModificaParagraph5_DE = "Bei Reservierungen, die lange im Voraus vorgenommen werden, wird empfohlen, die Option „später bezahlen“ zu nutzen, damit die Bedingungen vor der Zahlung verlässlicher geprüft werden können.";

  politicaModificaParagraph6_IT = "Con la conferma della prenotazione l’utente accetta integralmente le presenti condizioni.";
  politicaModificaParagraph6_EN = "By confirming the reservation, the user fully accepts these conditions.";
  politicaModificaParagraph6_FR = "En confirmant la réservation, l’utilisateur accepte intégralement les présentes conditions.";
  politicaModificaParagraph6_NL = "Met de bevestiging van de reservering aanvaardt de gebruiker deze voorwaarden volledig.";
  politicaModificaParagraph6_DE = "Mit der Bestätigung der Reservierung akzeptiert der Nutzer diese Bedingungen vollständig.";

  ombrelloniUmani_EN = "Human Umbrellas";
  ombrelloniUmani_IT = "Ombrelloni Umani";
  ombrelloniUmani_FR = "Parasols pour Humains";
  ombrelloniUmani_DE = "Sonnenschirme für Personen";

  ombrelloniUmaniDesc_EN = "First row: Max 4 people\n";
  ombrelloniUmaniDesc_DE = "Erste Reihe: max. 4 Personen\n";
  ombrelloniUmanOtherRowsiDesc_EN = "Other rows: max 2 people";
  ombrelloniUmanOtherRowsiDesc_DE = "Andere Reihen: max. 2 Personen";
  ombrelloniUmaniDesc_IT = "Prima fila Max 4 persone\n";
  ombrelloniUmaniOtherRowsDesc_IT = "Altre file: max 2 persone";
  ombrelloniUmaniOtherRowsDesc_DE = "Andere Reihen: max. 2 Personen";
  ombrelloniUmaniDesc_FR = "Première rangée: max 4 personnes\n ";
  ombrelloniUmaniOtherRowsDesc_FR = "Autre rangées; max 2 personnes";

  gazeboUmani_EN = "Human Gazebo";
  gazeboUmani_IT = "Gazebo Umani";
  gazeboUmani_FR = "Gazebo pour Humains";
  gazeboUmani_DE = "Gazebo für Personen";

  gazeboUmaniDesc_EN = "Max 6 people";
  gazeboUmaniDesc_IT = "Max 6 persone";
  gazeboUmaniDesc_FR = "Max 6 personnes";
  gazeboUmaniDesc_DE = "Max. 6 Personen";

  ombrelloniCaniGrandi_NL = "Grote Honden Parasols";
  ombrelloniCaniGrandiDesc_NL = "Eerste rij: Max 4 personen, 1 hond\nRijen 2, 3, 4, 5, 6: Max 2 personen, 1 hond";
  ombrelloniCaniGrandiOtherRowsDesc_NL = "Eerste rij: Max 4 personen, 1 hond\nRijen 2, 3, 4, 5, 6: Max 2 personen, 1 hond";
  ombrelloniCaniPiccoli_NL = "Kleine Honden Parasols";;
  ombrelloniCaniPiccoliDesc_NL = "Eerste rij: Max 4 personen, 2 honden\nRijen 2, 3, 4, 5, 6: Max 2 personen, 2 honden";
  ombrelloniCaniPiccoliOtherRowsDesc_NL = "Eerste rij: Max 4 personen, 2 honden\nRijen 2, 3, 4, 5, 6: Max 2 personen, 2 honden";
  gazeboCani_NL = "Honden Gazebo";;
  gazeboCaniDesc_NL = "Max 6 personen en 3 honden van elke grootte";
  ombrelloniUmani_NL = "Menselijke Parasols";;
  ombrelloniUmaniDesc_NL = "Eerste rij: Max 4; personen\nRijen 2, 3, 4: Max 2 personen";
  ombrelloniUmaniOtherRowDesc_NL = "Eerste rij: Max 4; personen\nRijen 2, 3, 4: Max 2 personen";
  ombrelloniUmaniOtherRowDesc_DE = "Erste Reihe: max. 4 Personen\nReihen 2, 3, 4: max. 2 Personen";
  gazeboUmani_NL = "Menselijke Gazebo";;
  gazeboUmaniDesc_NL = "Max 6 personen";

  infoLabel = "";
  ordiniLabel = "";
  profiloLabel = "";
  prenotaLabel = "";
  inPreparazioneLabel = "";
  menuDelGiornoLabel = "";
  riepilogoLabel = "";
  avantiLabel = "";

  prenotaTabBar = "";

  costoLabel_IT = "Costo";
  costoLabel_DE = "Preis";
  costoPagamentoOnlineLabel_IT = "Pagamento Online";
  costoPagamentoOnlineLabel_DE = "Online-Zahlung";
  costoLabel_EN = "Price";
  costoPagamentoOnlineLabel_EN = "Online Payment";
  costoLabel_FR = "Prix";
  costoPagamentoOnlineLabel_FR = "Paiement Online";
  modificaRicercaLabel_IT = "Modifica Ricerca";
  modificaRicercaLabel_EN = "Modify your search";
  modificaRicercaLabel_FR = "Modifier la recherche";
  modificaRicercaLabel_NL = "Zoekopdracht wijzigen";
  modificaRicercaLabel_DE = "Suche ändern";
  condizioniDiVenditaLabel_IT = "Confermo di aver preso visione delle condizioni di vendita";
  condizioniDiVenditaLabel_FR = "J'ai lu les conditions de vente";
  condizioniDiVenditaLabel_EN = "I have read the conditions of sale";
  condizioniDiVenditaLabel_NL = "Ik heb de voorwaarden van verkoop gelezen";
  condizioniDiVenditaLabel_DE = "Ich habe die Verkaufsbedingungen gelesen";
  ristoranteServizioSospesoLabel_IT = "Il servizio ristorante è temporaneamente sospeso.";
  ristoranteServizioSospesoLabel_EN = "The restaurant service is temporarily suspended."
  ristoranteServizioSospesoLabel_FR = "Le service de restauration est temporairement suspendu."
  ristoranteServizioSospesoLabel_NL = "Het restaurant dienservice is tijdelijk gesloten."
  ristoranteServizioSospesoLabel_DE = "Der Restaurantservice ist vorübergehend ausgesetzt.";
  chiudiLabel_IT = "Chiudi";
  chiudiLabel_EN = "Close";
  chiudiLabel_FR = "Ferme";
  chiudiLabel_NL = "Sluiten";
  chiudiLabel_DE = "Schließen";
  languageSelected = "IT"; // lingua default, viene sostituito dal codice della lingua selezionata
  flagLanguageSelected = "It"; // lingua delle bandierine da far vedere a video

  // Getter per il locale code da usare nei componenti ion-datetime
  get localeCode(): string {
    switch (this.languageSelected?.toUpperCase()) {
      case 'EN':
        return 'en-US';
      case 'FR':
        return 'fr-FR';
      case 'NL':
        return 'nl-NL';
      case 'DE':
        return 'de-DE';
      case 'IT':
      default:
        return 'it-IT';
    }
  }

  // Getter per il locale di date-fns da usare nelle funzioni format()
  get dateFnsLocale(): Locale {
    switch (this.languageSelected?.toUpperCase()) {
      case 'EN':
        return enUS;
      case 'FR':
        return fr;
      case 'NL':
        return nl;
      case 'DE':
        return de;
      case 'IT':
      default:
        return it;
    }
  }
  annullaAcquistoLabel_IT = "Annulla Acquisto";
  annullaAcquistoLabel_EN = "Cancel Purchase";
  annullaAcquistoLabel_FR = "Annuler l'achat";
  annullaAcquistoLabel_NL = "Aankoop annuleren";
  annullaAcquistoLabel_DE = "Kauf abbrechen";
  checkoutCarrelloConcludiOrdineLabel_EN = "Complete your order";
  checkoutCarrelloConcludiOrdineLabel_FR = "Terminez le commande";
  checkoutCarrelloConcludiOrdineLabel_NL = "Bestelling voltooien";
  checkoutCarrelloConcludiOrdineLabel_IT = "Concludi Prenotazione";
  checkoutCarrelloConcludiOrdineLabel_DE = "Bestellung abschließen";
  orarioLimiteLabel_EN = 'With cash payment it is necessary to arrive by 10am for "full day" and "morning" and by 3pm for "afternoon"';
  orarioLimiteLabel_FR = "Avec le paiement en espèces, il est nécessaire d'arriver avant 10h00 pour la `` journée complète '' et le `` matin '' et avant 15h00 pour `` l'après-midi ''"
  orarioLimiteLabel_IT = "Con pagamento in contanti è necessario presentarsi entro le ore 10 per 'intera giornata' e 'mattina' ed entro le ore 15 per il 'pomeriggio'";
  orarioLimiteLabel_NL = "Bij contante betaling moet u voor 10.00 uur arriveren voor 'hele dag' en 'ochtend' en voor 15.00 uur voor 'middag'";
  orarioLimiteLabel_DE = 'Bei Barzahlung müssen Sie für "ganzer Tag" und "Vormittag" bis 10:00 Uhr und für "Nachmittag" bis 15:00 Uhr ankommen';
  prenotazioneDaSaldareLabel_IT = "Prenotazione da saldare";
  prenotazioneDaSaldareLabel_DE = "zu zahlende Buchung";
  prenotazioneSaldataLabel_IT = "Prenotazione saldata";
  prenotazioneSaldataLabel_DE = "bezahlte Buchung";
  prenotazioneDaSaldareLabel_FR = "réservation à payer";
  prenotazioneSaldataLabel_FR = "réservation payée";
  prenotazioneDaSaldareLabel_EN = "reservation to be paid";
  prenotazioneSaldataLabel_EN = "reservation paid";
  prenotazioneDaSaldareLabel_NL = "Reservering die moet worden betaald";
  prenotazioneSaldataLabel_NL = "Reservering betaald";
  /* LINGUA ITALIANA */
  appUpdateLabel_IT = "Aggiorna App";
  appUpdateLabel_DE = "App aktualisieren";
  prenotaAsportoLabel_IT = "La prenotazione è per il giorno corrente";
  prenotaAsportoLabel_DE = "Die Buchung gilt für heute";
  sdraioSingolaLabel_IT = "Sdraio";
  sdraioSingolaLabel_DE = "Liege";
  sdraioMultipleLabel_IT = "Sdraio";
  sdraioMultipleLabel_DE = "Liegen";
  lettinoSingoloLabel_IT = "Lettino";
  lettinoSingoloLabel_DE = "Strandliege";
  lettiniMultipliLabel_IT = "Lettini";
  lettiniMultipliLabel_DE = "Strandliegen";
  accessoriExtraGazeboLabel_IT = "1 Sedia Regista 1 Amaca 1 Tavolo";
  accessoriExtraGazeboLabel_DE = "1 Regiestuhl 1 Hängematte 1 Tisch";
  aggiornaDatiLabel_IT = "Aggiorna Profilo";
  aggiornaDatiLabel_DE = "Profil aktualisieren";
  aggiungiCarrelloLabel_IT = "Aggiungi al carrello";
  aggiungiCarrelloLabel_DE = "In den Warenkorb";
  alDateLabel_IT = "A:";
  alDateLabel_DE = "Bis:";
  alertAppObsoleta_IT = "Versione App Obsoleta";
  alertAppObsoleta_DE = "Ihre App-Version ist veraltet";
  alertAppObsoletaMess_IT = "Aggiornare l\'applicazione per continuare ad utilizzarla. In alcuni casi potrebbe essere necessario disinstallare la vecchia versione e procedere con l\'installazione dell\'ultima versione disponibile sullo store.";
  alertAppObsoletaMess_DE = "Bitte aktualisieren Sie die App, um sie weiter zu nutzen. In einigen Fällen kann es erforderlich sein, die alte Version zu deinstallieren und die neueste Version aus dem Store zu installieren.";
  alertAppInAggiornamento_IT = "Manutenzione in corso";
  alertAppInAggiornamento_DE = "Wartung läuft";
  alertAppInAggiornamentoMess_IT = "Sarà possibile utilizzare l'app al più presto.";
  alertAppInAggiornamentoMess_DE = "Die App ist in Kürze wieder verfügbar.";
  alertDopoLeDodiciLabel_IT = "E\' possibile prenotare solo per cena o per i giorni successivi";
  alertDopoLeDodiciLabel_DE = "Sie können nur für das Abendessen oder für die nächsten Tage buchen";
  alertDopoLeUndiciLabel_IT = "Dopo le ore 11 e\' possibile prenotare solo per i giorni successivi";
  alertDopoLeUndiciLabel_DE = "Nach 11:00 Uhr können Sie nur für die nächsten Tage buchen";
  alertDopoLeVentiLabel_IT = "E\' possibile prenotare solo per giorni differenti";
  alertDopoLeVentiLabel_DE = "Sie können nur für andere Tage buchen";
  alertDopoLeOttoLabel_IT = "Dopo le ore 18 non e\' possibile effettuare prenotazioni per il giorno corrente. E\' possibile prenotare solo per i giorni successivi";
  alertDopoLeOttoLabel_DE = "Nach 18:00 Uhr sind Buchungen für den aktuellen Tag nicht möglich. Sie können nur für die nächsten Tage buchen";
  alertError_IT = "Oops! Qualcosa non ha funzionato!";
  alertError_DE = "Ups! Etwas ist schiefgelaufen!";
  alertErroreDateLabel_IT = "La data di fine non può essere inferiore a quella di inizio";
  alertErroreDateLabel_DE = "Das Enddatum darf nicht vor dem Startdatum liegen";
  alertErroreLabel_IT = "Errore sulle date";
  alertErroreLabel_DE = "Datumsfehler";
  alertErrorMessage_IT = "Riprova :) Se l'errore persiste, prova ad effettuare il logout e riprovare";
  alertErrorMessage_DE = "Bitte erneut versuchen :) Wenn der Fehler bleibt, melden Sie sich ab und versuchen Sie es erneut";
  erroreRecuperoOrdineLabel_IT = "Impossibile recuperare i dati dell'ordine. Riprova.";
  erroreRecuperoOrdineLabel_EN = "Unable to retrieve order data. Please try again.";
  erroreRecuperoOrdineLabel_FR = "Impossible de recuperer les donnees de la commande. Veuillez reessayer.";
  erroreRecuperoOrdineLabel_NL = "Kan de bestelgegevens niet ophalen. Probeer het opnieuw.";
  erroreRecuperoOrdineLabel_DE = "Bestelldaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.";
  alertGiorniPassatiLabel_IT = "Non e\' possibile prenotare per giorni passati";
  alertGiorniPassatiLabel_DE = "Für vergangene Tage kann nicht gebucht werden :)";
  alertLetturaDati_IT = "Lettura dati in corso.";
  alertLetturaDati_DE = "Daten werden geladen...";
  alertMaxOmbrelloni_IT = "E\' possibile riservare al massimo 5 ombrelloni alla volta.";
  alertMaxOmbrelloni_DE = "Sie können maximal 5 Sonnenschirme gleichzeitig buchen.";
  alertOmbrNonDispLabel_IT = "L\'ombrellone selezionato non e\' piu\' disponibile, sceglierne un altro.";
  alertOmbrNonDispLabel_DE = "Der ausgewählte Sonnenschirm ist nicht mehr verfügbar. Bitte wählen Sie einen anderen.";
  alertPagamentoInCorso_IT = "Pagamento in corso.";
  alertPagamentoInCorso_DE = "Zahlung läuft...";
  alertPrenotaOmbrellone_IT = "Prenotazione Ombrellone";
  alertPrenotaOmbrellone_DE = "Sonnenschirm-Buchung";
  alertPrenotaRistorante_IT = "Prenotazione Ristorante";
  alertPrenotaRistorante_DE = "Restaurant-Buchung";
  alertSalvataggioInCorso_IT = "Salvataggio dati in corso.";
  alertSalvataggioInCorso_DE = "Daten werden gespeichert...";
  alertTempoScaduto_IT = "Tempo scaduto per la prenotazione degli ombrelloni riservati: il carrello e\' stato svuotato.";
  alertTempoScaduto_DE = "Reservierungszeit abgelaufen: Der Warenkorb wurde geleert.";
  alertUtentePassErrati_IT = "E-Mail o password errate";
  alertUtentePassErrati_DE = "Falsche E-Mail oder falsches Passwort";
  alertUtentePassRiprovare_IT = "Verificare i dati immessi e riprovare.";
  alertUtentePassRiprovare_DE = "Bitte Eingaben prüfen und erneut versuchen.";
  annullaLabel_IT = "Annulla";
  annullaLabel_DE = "Abbrechen";
  annullaLabelTornaIndietro_IT = "Torna Indietro";
  annullaLabelTornaIndietro_FR = "RETOURNER";
  annullaLabelTornaIndietro_NL = "GA TERUG";
  annullaLabelTornaIndietro_DE = "Zurück";
  avantiLabel_IT = "AVANTI";
  avantiLabel_DE = "WEITER";
  barSpiaggiaLabel_IT = "Ordini Spiaggia";
  barSpiaggiaLabel_DE = "Strandbestellungen";
  calcoloPrezzoLabel_IT = "Calcolo prezzo in corso...";
  calcoloPrezzoLabel_DE = "Preis wird berechnet...";
  carrelloLabel_IT = "Vai al carrello";
  carrelloLabel_DE = "Zum Warenkorb";
  ordineMinimoLabel_IT = "L'ordine minimo è di €{importo}";
  ordineMinimoLabel_DE = "Der Mindestbestellwert beträgt €{importo}";
  cartaCredito_aggiungiCartaLabel_IT = "Aggiungi carta";
  cartaCredito_aggiungiCartaLabel_DE = "Karte hinzufügen";
  cartaCredito_aggiungiCartaPagamentoLabel_IT = "AGGIUNGI O MODIFICA UNA CARTA";
  cartaCredito_aggiungiCartaPagamentoLabel_DE = "KARTE HINZUFÜGEN ODER ÄNDERN";
  cartaCredito_cambiaCartaLabel_IT = "Cambia carta";
  cartaCredito_cambiaCartaLabel_DE = "Karte ändern";
  cartaCredito_cartaLabel_IT = "Carta";
  cartaCredito_cartaLabel_DE = "Karte";
  cartaCredito_consegnaLabel_IT = "Consegna: ";
  cartaCredito_consegnaLabel_DE = "Lieferung: ";
  cartaCredito_errorMsgLabel_IT = "Siamo spiacenti, l'ordine non è andato a buon fine.";
  cartaCredito_errorMsgLabel_DE = "Es tut uns leid, etwas ist schiefgelaufen.";
  cartaCredito_esitoPagamentoLabel_IT = "Esito Pagamento";
  cartaCredito_esitoPagamentoLabel_DE = "Zahlungsergebnis";
  cartaCredito_modificaCartaLabel_IT = "Modifica Carta di Credito";
  cartaCredito_modificaCartaLabel_DE = "Kreditkarte ändern";
  cartaCredito_modificaCartaPagamentoLabel_IT = "Modifica carta di pagamento";
  cartaCredito_modificaCartaPagamentoLabel_DE = "Zahlungskarte ändern";
  cartaCredito_nessunaCartaLabel_IT = "Nessuna carta disponibile";
  cartaCredito_nessunaCartaLabel_DE = "Keine Karte verfügbar";
  cartaCredito_numeroCartaLabel_IT = "Numero Carta";
  cartaCredito_numeroCartaLabel_DE = "Kartennummer";
  cartaCredito_ordineCompletatoLabel_IT = "ORDINE COMPLETATO";
  cartaCredito_ordineCompletatoLabel_DE = "BESTELLUNG ABGESCHLOSSEN";
  cartaCredito_ordineMsgLabel_IT = "In caso di prenotazione ombrellone effettuata in contanti e' necessario presentarsi entro le ore 12.";
  cartaCredito_ordineMsgLabel_DE = "Der Sonnenschirm muss bis 12:00 Uhr belegt werden";
  cartaCredito_pagaConCartaLabel_IT = "Paga con carta di credito";
  cartaCredito_pagaConCartaLabel_DE = "Mit Kreditkarte bezahlen";
  cartaCredito_pagaOraLabel_IT = "PAGA ORA";
  cartaCredito_pagaOraLabel_DE = "JETZT BEZAHLEN";
  cartaCredito_rimuoviCartaLabel_IT = "Rimuovi carta";
  cartaCredito_rimuoviCartaLabel_DE = "Karte entfernen";
  cartaCredito_ritentaOrdineLabel_IT = "RITENTA ACQUISTO";
  cartaCredito_ritentaOrdineLabel_DE = "ERNEUT VERSUCHEN";
  cartaCredito_scadenzaCartaLabel_IT = "Scadenza";
  cartaCredito_scadenzaCartaLabel_DE = "Ablauf";
  cartaCredito_tornaHomeLabel_IT = "TORNA ALLA HOME";
  cartaCredito_tornaHomeLabel_DE = "ZUR HOME";
  cartaCredito_totaleOrdineLabel_IT = "Totale Ordine ";
  cartaCredito_totaleOrdineLabel_DE = "Gesamtbestellung";

  // --- Pagamento in elaborazione (auto-verifica ordine) ---
  pagamentoInElaborazioneTitleLabel_IT = "Pagamento in elaborazione";
  pagamentoInElaborazioneTitleLabel_EN = "Payment processing";
  pagamentoInElaborazioneTitleLabel_NL = "Betaling wordt verwerkt";
  pagamentoInElaborazioneTitleLabel_DE = "Zahlung wird verarbeitet";
  pagamentoInElaborazioneTitleLabel_FR = "Paiement en cours de traitement";

  pagamentoInElaborazioneMsgLabel_IT = "Stiamo confermando il tuo pagamento…";
  pagamentoInElaborazioneMsgLabel_EN = "We're confirming your payment…";
  pagamentoInElaborazioneMsgLabel_NL = "We bevestigen je betaling…";
  pagamentoInElaborazioneMsgLabel_DE = "Wir bestätigen deine Zahlung…";
  pagamentoInElaborazioneMsgLabel_FR = "Nous confirmons votre paiement…";

  pagamentoElaborazioneLungaMsgLabel_IT = "L'elaborazione del tuo ordine sta richiedendo più tempo del previsto. Controlla il Riepilogo ordini e la tua email fra qualche minuto: se l'ordine è presente, il pagamento è andato a buon fine. In caso di dubbi contattaci prima di effettuare un nuovo pagamento.";
  pagamentoElaborazioneLungaMsgLabel_EN = "Processing your order is taking longer than expected. Please check your Order summary and your email in a few minutes: if the order is there, the payment went through. If in doubt, contact us before making another payment.";
  pagamentoElaborazioneLungaMsgLabel_NL = "Het verwerken van je bestelling duurt langer dan verwacht. Controleer over een paar minuten je Besteloverzicht en je e-mail: als de bestelling er staat, is de betaling gelukt. Neem bij twijfel contact met ons op voordat je opnieuw betaalt.";
  pagamentoElaborazioneLungaMsgLabel_DE = "Die Verarbeitung deiner Bestellung dauert länger als erwartet. Bitte überprüfe in einigen Minuten deine Bestellübersicht und deine E-Mail: Wenn die Bestellung dort erscheint, war die Zahlung erfolgreich. Kontaktiere uns im Zweifel, bevor du erneut bezahlst.";
  pagamentoElaborazioneLungaMsgLabel_FR = "Le traitement de votre commande prend plus de temps que prévu. Vérifiez votre Récapitulatif de commande et votre e-mail dans quelques minutes : si la commande y figure, le paiement a été effectué. En cas de doute, contactez-nous avant d'effectuer un nouveau paiement.";

  vaiRiepilogoOrdiniLabel_IT = "Vai al Riepilogo ordini";
  vaiRiepilogoOrdiniLabel_EN = "Go to Order summary";
  vaiRiepilogoOrdiniLabel_NL = "Naar Besteloverzicht";
  vaiRiepilogoOrdiniLabel_DE = "Zur Bestellübersicht";
  vaiRiepilogoOrdiniLabel_FR = "Voir le récapitulatif";

  verificaOrdineTitleLabel_IT = "Verifica dell'ordine in corso";
  verificaOrdineTitleLabel_EN = "Verifying your order";
  verificaOrdineTitleLabel_NL = "Je bestelling wordt gecontroleerd";
  verificaOrdineTitleLabel_DE = "Deine Bestellung wird geprüft";
  verificaOrdineTitleLabel_FR = "Vérification de votre commande";

  verificaOrdineMsgLabel_IT = "Stiamo verificando lo stato del tuo ordine, attendi qualche secondo…";
  verificaOrdineMsgLabel_EN = "We're checking your order status, please wait a few seconds…";
  verificaOrdineMsgLabel_NL = "We controleren de status van je bestelling, een ogenblik geduld…";
  verificaOrdineMsgLabel_DE = "Wir prüfen den Status deiner Bestellung, bitte warte einen Moment…";
  verificaOrdineMsgLabel_FR = "Nous vérifions l'état de votre commande, veuillez patienter quelques secondes…";

  verificaNonCompletataTitleLabel_IT = "Verifica non completata";
  verificaNonCompletataTitleLabel_EN = "Verification not completed";
  verificaNonCompletataTitleLabel_NL = "Controle niet voltooid";
  verificaNonCompletataTitleLabel_DE = "Prüfung nicht abgeschlossen";
  verificaNonCompletataTitleLabel_FR = "Vérification non terminée";

  verificaOrdineNonConfermatoMsgLabel_IT = "Non siamo riusciti a confermare l'ordine. Controlla il Riepilogo ordini o l'email di conferma: se l'ordine è presente, il pagamento è andato a buon fine. In caso di dubbi contattaci prima di effettuare un nuovo pagamento.";
  verificaOrdineNonConfermatoMsgLabel_EN = "We couldn't confirm your order. Please check your Order summary or your confirmation email: if the order is there, the payment went through. If in doubt, contact us before making another payment.";
  verificaOrdineNonConfermatoMsgLabel_NL = "We konden je bestelling niet bevestigen. Controleer je Besteloverzicht of je bevestigingsmail: als de bestelling er staat, is de betaling gelukt. Neem bij twijfel contact met ons op voordat je opnieuw betaalt.";
  verificaOrdineNonConfermatoMsgLabel_DE = "Wir konnten deine Bestellung nicht bestätigen. Bitte prüfe deine Bestellübersicht oder deine Bestätigungs-E-Mail: Wenn die Bestellung dort erscheint, war die Zahlung erfolgreich. Kontaktiere uns im Zweifel, bevor du erneut bezahlst.";
  verificaOrdineNonConfermatoMsgLabel_FR = "Nous n'avons pas pu confirmer votre commande. Vérifiez votre Récapitulatif de commande ou votre e-mail de confirmation : si la commande y figure, le paiement a été effectué. En cas de doute, contactez-nous avant d'effectuer un nouveau paiement.";
  checkoutCarrelloCartaCreditoLabel_IT = "Carta di Credito";
  checkoutCarrelloCartaCreditoLabel_DE = "Kreditkarte";
  checkoutCarrelloConcludiPagamentoLabel_IT = "Concludi pagamento";
  checkoutCarrelloConcludiPagamentoLabel_DE = "Zahlung abschließen";
  checkoutCarrelloConsegnaOrdineBarLabel_IT = "Dove consegnare l'ordine?";
  checkoutCarrelloConsegnaOrdineBarLabel_DE = "Wohin soll Ihre Bestellung geliefert werden?";
  checkoutCarrelloConsegnaOrdineMsgLabel_IT = "Inserire dove consegnare l'ordine";
  checkoutCarrelloConsegnaOrdineMsgLabel_DE = "Bitte geben Sie den Lieferort Ihrer Bestellung ein";
  checkoutCarrelloContantiLabel_IT = "Paga alla cassa";
  checkoutCarrelloContantiLabel_DE = "An der Kasse bezahlen";
  checkoutCarrelloPagaDopoLabel_IT = "Paga dopo";
  checkoutCarrelloPagaDopoLabel_DE = "Später bezahlen";
  checkoutCarrelloPagaDopoNonDisponibileLabel_IT = "Pagamento \"Paga dopo\" non più disponibile: la prenotazione inizia tra meno di 24 ore. Scegli un altro metodo di pagamento.";
  checkoutCarrelloPagaDopoNonDisponibileLabel_EN = "\"Pay later\" is no longer available: the booking starts in less than 24 hours. Please choose another payment method.";
  checkoutCarrelloPagaDopoNonDisponibileLabel_FR = "Le mode « Payer plus tard » n'est plus disponible : la réservation commence dans moins de 24 heures. Veuillez choisir un autre mode de paiement.";
  checkoutCarrelloPagaDopoNonDisponibileLabel_NL = "\"Later betalen\" is niet meer beschikbaar: de reservering begint over minder dan 24 uur. Kies een andere betaalmethode.";
  checkoutCarrelloPagaDopoNonDisponibileLabel_DE = "\"Später bezahlen\" ist nicht mehr verfügbar: Die Reservierung beginnt in weniger als 24 Stunden. Bitte wählen Sie eine andere Zahlungsmethode.";
  checkoutCarrelloPagaDopoDisclaimerLabel_IT = "L'ordine prenotato con \"Paga dopo\" va pagato dalla propria area \"Riepilogo ordini\" entro 24 ore dalla data prenotata.";
  checkoutCarrelloPagaDopoDisclaimerLabel_DE = "Die mit \"Später bezahlen\" gebuchte Bestellung muss innerhalb von 24 Stunden ab dem gebuchten Datum im Bereich \"Bestellübersicht\" bezahlt werden.";
  checkoutCarrelloContinuaAcquistiLabel_IT = "Continua acquisti";
  checkoutCarrelloContinuaAcquistiLabel_DE = "Einkauf fortsetzen";
  checkoutCarrelloDataLabel_IT = "Data:";
  checkoutCarrelloDataLabel_DE = "Datum:";
  checkoutCarrelloLabel_IT = "Carrello";
  checkoutCarrelloLabel_DE = "Warenkorb";
  checkoutCarrelloMetodoPagamentoLabel_IT = "Seleziona metodo pagamento:";
  checkoutCarrelloMetodoPagamentoLabel_DE = "Zahlungsmethode auswählen:";
  checkoutCarrelloNoPagamentoLabel_IT = "Non è necessario alcun pagamento";
  checkoutCarrelloNoPagamentoLabel_DE = "Keine Zahlung erforderlich";
  checkoutCarrelloNrLettiniLabel_IT = "Numero Lettini:";
  checkoutCarrelloNrLettiniLabel_DE = "Anz. Strandliegen:";
  checkoutCarrelloNrSdraioLabel_IT = "Numero Sdraio:";
  checkoutCarrelloNrSdraioLabel_DE = "Anz. Liegen:";
  checkoutCarrelloNumeroPostiRistoranteLabel_IT = "Numero Posti Riservati:";
  checkoutCarrelloNumeroPostiRistoranteLabel_DE = "Anz. Plätze:";
  checkoutCarrelloOrarioLabel_IT = "Orario:";
  checkoutCarrelloOrarioLabel_DE = "Uhrzeit:";
  checkoutCarrelloOrdineBarLabel_IT = "Ordine Bar:";
  checkoutCarrelloOrdineBarLabel_DE = "Bar-Bestellung:";
  checkoutCarrelloOrdineOmbrelloniTimeoutLabel_IT = "Ordine Ombrelloni";
  checkoutCarrelloOrdineOmbrelloniTimeoutLabel_DE = "Sonnenschirm-Bestellung";
  checkoutCarrelloPagaLabel_IT = "Paga";
  checkoutCarrelloPagaLabel_DE = "Bezahlen";
  checkoutCarrelloPlaceHolderConsegnaLabel_IT = "Esempio: Ombrellone A11";
  checkoutCarrelloPlaceHolderConsegnaLabel_DE = "Beispiel: Sonnenschirm A11";
  checkoutCarrelloPrenotatoLabel_IT = "Riservato:";
  checkoutCarrelloPrenotatoLabel_DE = "Reserviert:";
  checkoutCarrelloQuandoLabel_IT = "Quando:";
  checkoutCarrelloQuandoLabel_DE = "Wann:";
  checkoutCarrelloRistoranteLabel_IT = "Ordine Ristorante:";
  checkoutCarrelloRistoranteLabel_DE = "Restaurant-Buchung:";
  checkoutCarrelloSvuotaCarrelloLabel_IT = "Svuota il	carrello";
  checkoutCarrelloSvuotaCarrelloLabel_DE = "Warenkorb leeren";
  checkoutCarrelloTotaleLabel_IT = "Totale:";
  checkoutCarrelloTotaleLabel_DE = "Gesamt:";
  checkoutCarrelloVuotoLabel_IT = "Il carrello è vuoto.";
  checkoutCarrelloVuotoLabel_DE = "Der Warenkorb ist leer.";
  ciaoUserLabel_IT = "Ciao";
  ciaoUserLabel_DE = "Hallo";
  confermaLabel_IT = "Conferma";
  confermaLabel_DE = "Bestätigen";
  confermaOmbrellone_Label_IT = "Conferma la tua prenotazione";
  confermaOmbrellone_Label_DE = "Buchung bestätigen";
  confermaRistorante_Label_IT = "Conferma la tua prenotazione";
  confermaRistorante_Label_DE = "Buchung bestätigen";
  dalDateLabel_IT = "Da:";
  dalDateLabel_DE = "Von:";
  dataLabel_IT = "Data:";
  dataLabel_DE = "Datum:";
  dayNamesLabel_IT = "Domenica -, Lunedi -, Martedi -, Mercoledi -, Giovedi -, Venerdi -, Sabato -";
  dayNamesLabel_DE = "Sonntag -, Montag -, Dienstag -, Mittwoch -, Donnerstag -, Freitag -, Samstag -";
  dogLabel_IT = "Accesso ai cani";
  dogLabel_DE = "Hunde willkommen";
  fasciaOrariaLabel_IT = "Orario?";
  fasciaOrariaLabel_DE = "Zeitfenster";
  finalitaTrattamento_IT = "Finalità Trattamento Dati";
  finalitaTrattamento_DE = "Zweck der Datenverarbeitung";
  giornataLabel_IT = "Intera Giornata";
  giornataLabel_DE = "Ganzer Tag";
  giorniMultipliLabel_IT = "Giorni Multipli";
  giorniMultipliLabel_DE = "Mehrere Tage";
  giorniPrenotatiLabel_IT = "Giorni prenotati:";
  giorniPrenotatiLabel_DE = "Gebuchte Tage:";
  hoDueCaniLabel_IT = "Ho due cani";
  hoDueCaniLabel_DE = "Ich habe zwei Hunde";
  home_dataDifferente_IT = "Scegliere una data differente";
  home_dataDifferente_DE = "Anderes Datum wählen";
  home_dayNames_IT = "Dom -, Lun -, Mar -, Mer -, Gio -, Ven -, Sab -";
  home_dayNames_DE = "So -, Mo -, Di -, Mi -, Do -, Fr -, Sa -";
  home_disponibiliLabel_IT = "Disponibili:";
  home_disponibiliLabel_DE = "Verfügbar:";
  home_monthShortNames_IT = "Gen, Feb, Mar, Apr, Mag, Giu, Lug, Ago, Set, Ott, Nov, Dic";
  home_monthShortNames_DE = "Jan, Feb, Mär, Apr, Mai, Jun, Jul, Aug, Sep, Okt, Nov, Dez";
  home_postiLabel_IT = "Posti";
  home_postiLabel_DE = "Plätze";
  home_prenotaOmbrellone_IT = "Prenota un ombrellone";
  home_prenotaOmbrellone_DE = "Sonnenschirm buchen";
  home_prenotaOnline_IT = "Prenota Online";
  home_prenotaOnline_DE = "Online buchen";
  home_prenotaRistorante_IT = "Prenota il ristorante";
  home_prenotaRistorante_DE = "Restaurant buchen";
  home_ristoranteLabel_IT = "RISTORANTE";
  home_ristoranteLabel_DE = "RESTAURANT";
  home_selezionaGiorno_IT = "Che Giorno?";
  home_selezionaGiorno_DE = "Wann?";
  homeCena_IT = "Cena";
  homeCena_DE = "Abendessen";
  homeNumeroCoperti_IT = "Numero coperti?";
  homeNumeroCoperti_DE = "Wie viele Plätze?";
  homePranzo_IT = "Pranzo";
  homePranzo_DE = "Mittagessen";
  homePranzoOCena_IT = "Vuoi prenotare a pranzo o cena?";
  homePranzoOCena_DE = "Möchten Sie Mittag- oder Abendessen buchen?";
  homePrenotaLabel_IT = "Prenota";
  homePrenotaLabel_DE = "Buchen";
  homeScegliNumeroCoperti_IT = "Scegliere il numero di coperti";
  homeScegliNumeroCoperti_DE = "Bitte Anzahl der Plätze wählen";
  homeSelezionaOrario_IT = "Seleziona l'orario";
  homeSelezionaOrario_DE = "Uhrzeit auswählen";
  homeSelezionaOrarioMsg_IT = "Per favore scegliere un orario";
  homeSelezionaOrarioMsg_DE = "Bitte die Uhrzeit auswählen";
  homeServizioBar_IT = "Il servizio bar sarà attivato a breve.";
  homeServizioBar_DE = "Der Service wird so bald wie möglich verfügbar sein.";
  infoAccessLabel_IT = "Accessibilità";
  infoAccessLabel_DE = "Barrierefreiheit";
  infoComunicazioniLabel_IT = "Per comunicazioni e segnalazioni, scrivere a ";
  infoComunicazioniLabel_DE = "Für weitere Informationen schreiben Sie an ";
  infoCusciniLabel_IT = "Cuscini";
  infoCusciniLabel_DE = "Kissen für";
  infoDocceLabel_IT = "Docce";
  infoDocceLabel_DE = "Duschen";
  infoFilaLabel_IT = "Fila";
  infoFilaLabel_DE = "Reihe";
  infoLabel_IT = "Info";
  infoLabel_DE = "Info";
  infonNoleggioLabel_IT = "Noleggio";
  infonNoleggioLabel_DE = "Verleih";
  infoParcheggioLabel_IT = "Parcheggio";
  infoParcheggioLabel_DE = "Parkplatz";
  infoPrezziLabel_IT = "Prezzi";
  infoPrezziLabel_DE = "Preise";
  infoRistoranteLabel_IT = "Ristorante";
  infoRistoranteLabel_DE = "Restaurant";
  infoServiziLabel_IT = "I nostri servizi";
  infoServiziLabel_DE = "Unsere Leistungen";
  inPreparazioneLabel_IT = "in preparazione";
  inPreparazioneLabel_DE = "bald verfügbar";
  inserisciDatiLabel_IT = "Inserisci i dati:";
  inserisciDatiLabel_DE = "Wählen Sie Ihren Sonnenschirm:";
  insertName_IT = "Inserire il proprio nome";
  insertName_DE = "Bitte geben Sie Ihren Namen ein";
  insertSurname_IT = "Inserire il proprio cognome";
  insertSurname_DE = "Bitte geben Sie Ihren Nachnamen ein";
  invalidPhone_IT = "Lunghezza errata: cellulare non valido.";
  invalidPhone_DE = "Ungültige Telefonnummer";
  isCarrelloIbridoLabel_IT = "NON E' POSSIBILE ACQUISTARE CONTEMPORANEAMENTE SERVIZI ED OMBRELLONI, EFFETTUARE IL PAGAMENTO DI UN ELEMENTO ALLA VOLTA";
  isCarrelloIbridoLabel_DE = "SIE KÖNNEN NICHT GLEICHZEITIG SERVICES, GETRÄNKE UND SONNENSCHIRME KAUFEN. BITTE JEWEILS NUR EINE KATEGORIE BEZAHLEN";
  lettinoAggiuntivoLabel_IT = "Lettino aggiuntivo";
  lettinoAggiuntivoLabel_DE = "Zusätzliche Strandliege";
  lettinoLabel_IT = "LETTINO";
  lettinoLabel_DE = "STRANDLIEGE";
  listaCaniLabel_IT = "Lista Cani:";
  listaCaniLabel_DE = "Hundeliste:";
  listaOrdiniLabel_IT = "Ordini";
  listaOrdiniLabel_DE = "Bestellungen";
  lunghMaxDodCar_IT = "Lunghezza massima 12 caratteri";
  lunghMaxDodCar_DE = "Maximale Länge 12 Zeichen";
  lunghMaxVentiCar_IT = "Lunghezza massima 20 caratteri";
  lunghMaxVentiCar_DE = "Maximale Länge 20 Zeichen";
  lunghMaxVentiCinqueCar_IT = "Lunghezza massima 25 caratteri";
  lunghMaxVentiCinqueCar_DE = "Maximale Länge 25 Zeichen";
  lunghMinDueCar_IT = "Lunghezza minima 2 caratteri";
  lunghMinDueCar_DE = "Mindestlänge 2 Zeichen";
  lunghMinSeiCar_IT = "Lunghezza minima 6 caratteri";
  lunghMinSeiCar_DE = "Mindestlänge 6 Zeichen";
  lunghMinTreCar_IT = "Lunghezza minima 3 caratteri";
  lunghMinTreCar_DE = "Mindestlänge 3 Zeichen";
  mattinaLabel_IT = "Mattina";
  mattinaLabel_DE = "Vormittag";
  maxPostiPren_IT = "Numero massimo posti prenotabili:";
  maxPostiPren_DE = "Verfügbare Plätze:";
  menuDelGiornoLabel_IT = "Menu del giorno";
  menuDelGiornoLabel_DE = "Tagesmenü";
  menuPubblicoChiudiLabel_IT = "CHIUDI";
  menuPubblicoChiudiLabel_DE = "ZURÜCK";
  modificaProfiloLabel_IT = "Modifica Profilo";
  modificaProfiloLabel_DE = "Profil bearbeiten";
  monthLongNames_IT = "Gennaio, Febbraio, Marzo, Aprile, Maggio, Giugno, Luglio, Agosto, Settembre, Ottobre, Novembre, Dicembre";
  monthLongNames_DE = "Januar, Februar, März, April, Mai, Juni, Juli, August, September, Oktober, November, Dezember";
  nessunoLabel_IT = "NESSUNO";
  nessunoLabel_DE = "NICHTS";
  nessunOrdineLabel_IT = "Nessun ordine presente";
  nessunOrdineLabel_DE = "Sie haben keine Bestellungen";
  nienteSdraioLabel_IT = "Non ci sono sdraio disponibili.";
  nienteSdraioLabel_DE = "Es sind keine Strandliegen verfügbar.";
  nomeCaneDue_IT = "Nome Cane Due";
  nomeCaneDue_DE = "Hund zwei:";
  nomeCaneUno_IT = "Nome Cane Uno";
  nomeCaneUno_DE = "Hund eins:";
  numeroCopertiLabel_IT = "Numero Coperti:";
  numeroCopertiLabel_DE = "Plätze:";
  numeroLettiniLabel_IT = "Lettini:";
  numeroLettiniLabel_DE = "Betten:";
  numeroSdraioLabel_IT = "Sdraio:";
  numeroSdraioLabel_DE = "Liegen:";
  numeroSeduteLabel_IT = "Sedute";
  numeroSeduteLabel_DE = "Anz. Plätze";
  numeroServiziAggLabel_IT = "Numero servizi aggiuntivi: ";
  numeroServiziAggLabel_DE = "Zusätzliche Leistungen: ";
  obbligoDueSdraioLabel_IT = "E' obbligatorio prenotare almeno 2 sdraio.";
  obbligoDueSdraioLabel_DE = "Sie müssen mindestens 2 Strandliegen buchen.";
  obbligoUnaSdraioLabel_IT = "E' obbligatorio prenotare almeno 1 sdraio.";
  obbligoUnaSdraioLabel_DE = "Sie müssen mindestens 1 Strandliege buchen.";
  ombrelloneLabel_IT = "Ombrellone";
  ombrelloneLabel_DE = "Sonnenschirm";
  onlyLetters_IT = "Inserire solo lettere";
  onlyLetters_DE = "Nur Buchstaben eingeben";
  onlyNumbers_IT = "Inserire solo numeri";
  onlyNumbers_DE = "Nur Zahlen eingeben";
  ordineEffettuatoLabel_IT = "Ordine Effetuato";
  ordineEffettuatoLabel_DE = "Bestellliste ";
  ordineNrLabel_IT = "Prenotazione N.";
  ordineNrLabel_DE = "Buchungsnr.";
  pomeriggioLabel_IT = "Pomeriggio";
  pomeriggioLabel_DE = "Nachmittag";
  posizioneLabel_IT = "Posizione:";
  posizioneLabel_DE = "Position:";
  postiDisp_IT = "Non sono rimasti posti disponibili.";
  postiDisp_DE = "Es sind keine Plätze verfügbar.";
  pranzoCena_IT = "Pranzo o Cena?";
  pranzoCena_DE = "Mittag- oder Abendessen?";
  prenotaPostoLabel_IT = "Riserva un ombrellone";
  prenotaPostoLabel_DE = "Sonnenschirm buchen";
  prenotaTabBar_IT = "Prenota";
  prenotaTabBar_DE = "Buchen";
  prenotaPostoSoleLabel_IT = "Prenota il tuo posto al sole";
  prenotaPostoSoleLabel_EN = "Book your place in the sun";
  prenotaPostoSoleLabel_FR = "Réservez votre place au soleil";
  prenotaPostoSoleLabel_NL = "Boek uw plekje in de zon";
  prenotaPostoSoleLabel_DE = "Buche deinen Platz in der Sonne";
  prenotazioneLabel_IT = "Pranzo o Cena?";
  prenotazioneLabel_DE = "Mittag- oder Abendessen?";
  proseguiGuestLabel_IT = "Prosegui come ospite";
  proseguiGuestLabel_DE = "Als Gast fortfahren";
  resetPass_cambiaPassword_IT = "Modifica Password";
  resetPass_cambiaPassword_DE = "Passwort ändern";
  resetPass_confermaCambioLabel_IT = "Riceverai una email di conferma all'indirizzo indicato";
  resetPass_confermaCambioLabel_DE = "Sie erhalten eine Bestätigungs-E-Mail";
  resetPass_diversePassword_IT = "Le password inserite sono diverse";
  resetPass_diversePassword_DE = "Die Passwörter sind unterschiedlich";
  resetPass_emailNonValida_IT = "Indirizzo E-Mail non valido";
  resetPass_emailNonValida_DE = "Ungültige E-Mail-Adresse";
  resetPass_inserireMail_IT = "Per favore inserire la propria e-mail";
  resetPass_inserireMail_DE = "Bitte geben Sie Ihre E-Mail-Adresse ein";
  resetPass_inserirePassword_IT = "Per favore inserire una password";
  resetPass_inserirePassword_DE = "Bitte wählen Sie ein Passwort";
  resetPass_inserisciDatiLabel_IT = "Inserisci i tuoi dati per resettare la password:";
  resetPass_inserisciDatiLabel_DE = "Geben Sie Ihre Daten ein, um das Passwort zurückzusetzen:";
  resetPass_modificaLabel_IT = "Modifica la tua password";
  resetPass_modificaLabel_DE = "Passwort zurücksetzen";
  resetPass_msgConfermaLabel_IT = "Clicca sulla e-mail di conferma per accedere con la nuova password  ";
  resetPass_msgConfermaLabel_DE = "Klicken Sie auf die Bestätigungs-E-Mail, um sich mit dem neuen Passwort anzumelden ";
  resetPass_reinserirePassword_IT = "Per favore ridigitare la password";
  resetPass_reinserirePassword_DE = "Bitte geben Sie das Passwort erneut ein";
  resetPass_riscriviLabel_IT = "Riscrivi";
  resetPass_riscriviLabel_DE = "Erneut eingeben";
  resetPass_spamLabel_IT = "(Controllare la posta indesiderata)";
  resetPass_spamLabel_DE = "(Spam-Ordner prüfen)";
  riepilogoLabel_IT = "riepilogo";
  riepilogoLabel_DE = "Bestellübersicht";
  ristorante_confermaLabel_IT = "Conferma Prenotazione";
  ristorante_confermaLabel_DE = "Buchen";
  ristorante_disponibiliLabel_IT = "Disponibili:";
  ristorante_disponibiliLabel_DE = "Verfügbar:";
  ristorante_postiLabel_IT = "Posti";
  ristorante_postiLabel_DE = "Plätze";
  ristoranteLabel_IT = "Ristorante";
  ristoranteLabel_DE = "Restaurant";
  scegliDataLabel_IT = "Per favore scegliere una data";
  scegliDataLabel_DE = "Bitte ein Datum auswählen";
  scegliOmbrelloLabel_IT = "Scegli un Ombrellone";
  scegliOmbrelloLabel_DE = "Sonnenschirm auswählen";
  sdraioAggiuntivaLabel_IT = "Sdraio aggiuntiva";
  sdraioAggiuntivaLabel_DE = "Zusätzliche Liege";
  sdraioAggLabel_IT = "SDRAIO";
  sdraioAggLabel_DE = "LIEGE";
  sdraioLabel_IT = "Sdraio:";
  sdraioLabel_DE = "Liegen:";
  seduteAggLabel_IT = "SEDUTE AGGIUNTIVE";
  seduteAggLabel_DE = "ZUSÄTZLICHE STRANDLIEGEN";
  signup_account_IT = "Creazione Account";
  signup_account_DE = "Konto erstellen";
  signup_cognome_IT = "Cognome";
  signup_cognome_DE = "Nachname";
  signup_completa_messDati_IT = "Per poter procedere è necessario inserire <br> tutti i dati richiesti.";
  signup_completa_messDati_DE = "Um fortzufahren, geben Sie bitte alle angeforderten Daten ein.";
  signup_completaRegistrazione_IT = "Completa Registrazione";
  signup_completaRegistrazione_DE = "Registrierung abschließen";
  signup_emailNonValida_IT = "Indirizzo E-Mail non valido";
  signup_emailNonValida_DE = "Ungültige E-Mail-Adresse";
  signup_inserireMail_IT = "Per favore inserire la propria e-mail";
  signup_inserireMail_DE = "Bitte geben Sie Ihre E-Mail-Adresse ein";
  signup_inserirePassword_IT = "Per favore inserire una password";
  signup_inserirePassword_DE = "Bitte wählen Sie ein Passwort";
  signup_inserireTelefono_IT = "Inserire il proprio numero di telefono";
  signup_inserireTelefono_DE = "Bitte geben Sie Ihre Telefonnummer ein";
  signup_nome_IT = "Nome";
  signup_nome_DE = "Name";
  signup_presoVisioneInformativa_IT = "Dichiaro di aver preso visione dell'informativa <br>sul Trattamento dei dati personali";
  signup_presoVisioneInformativa_DE = "Ich habe die Informationen zur Verarbeitung <br> personenbezogener Daten gelesen";
  signup_presoVisioneTrattamento_IT = "Dichiaro di aver preso visione dell'informativa <br>sulla Finalità del trattamento";
  signup_presoVisioneTrattamento_DE = "Ich habe die Informationen zum Zweck <br> der Datenverarbeitung gelesen";
  signup_telefono_IT = "Telefono";
  signup_telefono_DE = "Telefon";
  tagliaCaneLabel_IT = "Taglia del Cane";
  tagliaCaneLabel_DE = "Hundegröße";
  tagliaGrandeLabel_IT = "Grande";
  tagliaGrandeLabel_DE = "Groß";
  tagliaPiccolaLabel_IT = "Piccola";
  tagliaPiccolaLabel_DE = "Klein";
  totaleLabel_IT = "Totale:";
  totaleLabel_DE = "Gesamt:";
  totaleParzialeLabel_IT = "Totale Parziale:";
  totaleParzialeLabel_DE = "Zwischensumme:";
  trattametoDati_IT = "Trattamento Dati Personali";
  trattametoDati_DE = "Verarbeitung personenbezogener Daten";
  verificaDispLabel_IT = "Verifica Disponibilità";
  verificaDispLabel_DE = "Verfügbarkeit prüfen";
  viaggiaConCaniLabel_IT = "Viaggia con Cani?";
  viaggiaConCaniLabel_DE = "Reisen Sie mit Hunden?";
  viaggiaConCaniSiLabel_IT = "Si";
  viaggiaConCaniSiLabel_DE = "Ja";
  welcome_emailNonValida_IT = "Indirizzo E-Mail non valido";
  welcome_emailNonValida_DE = "Ungültige E-Mail-Adresse";
  welcome_fbLogin_IT = "Login con Facebook";
  welcome_fbLogin_DE = "Facebook-Login";
  welcome_inserireMail_IT = "Per favore inserire la propria e-mail";
  welcome_inserireMail_DE = "Bitte geben Sie Ihre E-Mail-Adresse ein";
  welcome_inserirePassword_IT = "Per favore inserire una password";
  welcome_inserirePassword_DE = "Bitte wählen Sie ein Passwort";
  welcome_passDimenticata_IT = "Hai dimenticato la password?";
  welcome_passDimenticata_DE = "Passwort vergessen?";
  welcome_registrati_IT = "Registrati";
  welcome_registrati_DE = "Registrieren";
  ordineProntoLabel_IT = "Ordine pronto";
  ordineProntoLabel_DE = "Ihre Bestellung ist fertig";
  ordineNonProntoLabel_IT = "Ordine non ancora pronto";
  ordineNonProntoLabel_DE = "Die Bestellung ist noch nicht fertig";
  ordineInGestioneLabel_IT = "Ordine in gestione";
  ordineInGestioneLabel_DE = "Bestellung in Vorbereitung";
  richiesteParticolariLabel_IT = "Aggiungi eventuali richieste particolari...";
  richiesteParticolariLabel_DE = "Sonderwünsche hinzufügen...";
  costoCopertoLabel_IT = "Il costo del coperto è di 2 € a persona";
  costoCopertoLabel_DE = "Der Gedeckpreis beträgt 2 € pro Person";
  garanziaPrenotazioneRistoranteLabel_IT = "Le prenotazioni sono garantite fino a 15 minuti dall'orario prenotato. In caso di ritardo superiore la prenotazione potrebbe non essere garantita.";
  garanziaPrenotazioneRistoranteLabel_DE = "Reservierungen sind bis zu 15 Minuten nach der gebuchten Uhrzeit garantiert. Bei einer längeren Verspätung kann die Reservierung möglicherweise nicht garantiert werden.";
  /* FINE LINGUA ITALIANA */

  /* LINGUA INGLESE */
  appUpdateLabel_EN = "App Update";
  ordineInGestioneLabel_EN = "Order in preparation";
  ordineProntoLabel_EN = "Your order is ready";
  ordineNonProntoLabel_EN = "The order isn't ready yet";
  prenotaAsportoLabel_EN = "The reservation is for today";
  accessoriExtraGazeboLabel_EN = "1 Direction Chair 1 Hammock 1 Table";
  sdraioSingolaLabel_EN = "Deck Chair";
  sdraioMultipleLabel_EN = "Deck Chairs";
  lettinoSingoloLabel_EN = "Sea bed";
  lettiniMultipliLabel_EN = "Sea Beds";
  aggiornaDatiLabel_EN = "Update Profile";
  aggiungiCarrelloLabel_EN = "Add to cart";
  alDateLabel_EN = "To:";
  alertAppObsoleta_EN = "Your App Version is out of date";
  alertAppObsoletaMess_EN = "Please update the app if you want to use it. In some cases, you may need to uninstall the old version and install the latest version available on the store.";
  alertAppInAggiornamento_EN = "Work In Progress";
  alertAppInAggiornamentoMess_EN = "You will be able to use the app soon.";
  alertDopoLeDodiciLabel_EN = "You can only book for dinner or for the next days";
  alertDopoLeUndiciLabel_EN = "After 11am you can only book for the next days";
  alertDopoLeVentiLabel_EN = "You can only book for other days";
  alertDopoLeOttoLabel_EN = "After 6:00 PM it is not possible to make reservations for the current day. You can only book for the next days";
  alertError_EN = "Oops! Something bad just happened!";
  alertErroreDateLabel_EN = "The end date cannot be smaller than the start date";
  alertErroreLabel_EN = "Date Selection Error";
  alertErrorMessage_EN = "Try again :) If the error persists, logout and try again please";
  alertGiorniPassatiLabel_EN = "You can't go back in time :)";
  alertLetturaDati_EN = "Data reading...";
  alertMaxOmbrelloni_EN = "You can book max 5 umbrellas at once."
  alertOmbrNonDispLabel_EN = "The selected umbrella is no longer available, choose another one.";
  alertPagamentoInCorso_EN = "Payment...";
  alertPrenotaOmbrellone_EN = "Beach Umbrella Booking";
  alertPrenotaRistorante_EN = "Restaurant Booking";
  alertSalvataggioInCorso_EN = "Saving data...";
  alertTempoScaduto_EN = "Time expired for reserving: the cart has been emptied.";
  alertUtentePassErrati_EN = "Wrong E-mail or Password";
  alertUtentePassRiprovare_EN = "Check the entered data and try again.";
  annullaLabel_EN = "Cancel";
  annullaLabelTornaIndietro_EN = "Go Back";
  avantiLabel_EN = "PROCEED";
  barSpiaggiaLabel_EN = "Beach Orders";
  calcoloPrezzoLabel_EN = "Price calculation...";
  carrelloLabel_EN = "Go to cart";
  ordineMinimoLabel_EN = "The minimum order is €{importo}";
  cartaCredito_aggiungiCartaLabel_EN = "Add Card";
  cartaCredito_aggiungiCartaPagamentoLabel_EN = "ADD OR MODIFY CARD";
  cartaCredito_cambiaCartaLabel_EN = "Change Card";
  cartaCredito_cartaLabel_EN = "Card";
  cartaCredito_consegnaLabel_EN = "Delivery: ";
  cartaCredito_errorMsgLabel_EN = "We are sorry, something went wrong.";
  cartaCredito_esitoPagamentoLabel_EN = "Payment Result";
  cartaCredito_modificaCartaLabel_EN = "Modify Credit Card";
  cartaCredito_modificaCartaPagamentoLabel_EN = "Modify payment card";
  cartaCredito_nessunaCartaLabel_EN = "No cards available";
  cartaCredito_numeroCartaLabel_EN = "Card Number";
  cartaCredito_ordineCompletatoLabel_EN = "ORDER COMPLETED";
  cartaCredito_ordineMsgLabel_EN = "The beach umbrella must be occupied by noon";
  cartaCredito_pagaConCartaLabel_EN = "Pay with Credit Card";
  cartaCredito_pagaOraLabel_EN = "PAY NOW";
  cartaCredito_rimuoviCartaLabel_EN = "Remove Card";
  cartaCredito_ritentaOrdineLabel_EN = "TRY AGAIN";
  cartaCredito_scadenzaCartaLabel_EN = "Expiry";
  cartaCredito_tornaHomeLabel_EN = "GO TO HOME";
  cartaCredito_totaleOrdineLabel_EN = "Total Order";
  checkoutCarrelloCartaCreditoLabel_EN = "Credit Card";
  checkoutCarrelloConcludiPagamentoLabel_EN = "Complete payment";
  checkoutCarrelloConsegnaOrdineBarLabel_EN = "Where to deliver your order?";
  checkoutCarrelloConsegnaOrdineMsgLabel_EN = "Please, enter where to deliver your order";
  checkoutCarrelloContantiLabel_EN = "Pay at the counter";
  checkoutCarrelloPagaDopoLabel_EN = "Pay later";
  checkoutCarrelloPagaDopoDisclaimerLabel_EN = "The order booked with \"Pay later\" must be paid from your \"Order summary\" area within 24 hours of the booked date.";
  checkoutCarrelloContinuaAcquistiLabel_EN = "Continue shopping";
  checkoutCarrelloDataLabel_EN = "Date:";
  checkoutCarrelloLabel_EN = "Cart";
  checkoutCarrelloMetodoPagamentoLabel_EN = "Select a payment method:";
  checkoutCarrelloNoPagamentoLabel_EN = "No Payment Needed";
  checkoutCarrelloNrLettiniLabel_EN = "Nr. of sea beds:";
  checkoutCarrelloNrSdraioLabel_EN = "Nr. of deck chairs:";
  checkoutCarrelloNumeroPostiRistoranteLabel_EN = "Nr of seats:";
  checkoutCarrelloOrarioLabel_EN = "Hour:";
  checkoutCarrelloOrdineBarLabel_EN = "Bar Order:";
  checkoutCarrelloOrdineOmbrelloniTimeoutLabel_EN = "Umbrellas Order";
  checkoutCarrelloPagaLabel_EN = "Pay";
  checkoutCarrelloPlaceHolderConsegnaLabel_EN = "Example: Umbrella A11";
  checkoutCarrelloPrenotatoLabel_EN = "Booked:";
  checkoutCarrelloQuandoLabel_EN = "When:";
  checkoutCarrelloRistoranteLabel_EN = "Restaurant booking:";
  checkoutCarrelloSvuotaCarrelloLabel_EN = "Empty cart";
  checkoutCarrelloTotaleLabel_EN = "Total:";
  checkoutCarrelloVuotoLabel_EN = "The cart is empty.";
  ciaoUserLabel_EN = "Hi";
  confermaLabel_EN = "Confirm";
  confermaOmbrellone_Label_EN = "Confirm your booking";
  confermaRistorante_Label_EN = "Confirm your booking";
  dalDateLabel_EN = "From:";
  dataLabel_EN = "Date:";
  dayNamesLabel_EN = "Sunday -, Monday -,  Tuesday-,  Wednesday-, Thursday -, Friday -, Saturday -";
  dogLabel_EN = "Dogs are welcome";
  fasciaOrariaLabel_EN = "Time Slot";
  finalitaTrattamento_EN = "Data Treatment Purpose";
  giornataLabel_EN = "All Day";
  giorniMultipliLabel_EN = "Multiple Days";
  giorniPrenotatiLabel_EN = "Days Booked:";
  hoDueCaniLabel_EN = "I Have two dogs";
  home_dataDifferente_EN = "Pick a different Date";
  home_dayNames_EN = "Sun -, Mon -, Tue -, Wed -, Thu -, Fri -, Sat -";
  home_disponibiliLabel_EN = "Available:";
  home_monthShortNames_EN = "Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec";
  home_postiLabel_EN = "Seats";
  home_prenotaOmbrellone_EN = "Book an Umbrella";
  home_prenotaOnline_EN = "Book Online";
  home_prenotaRistorante_EN = "Book the restaurant"
  home_ristoranteLabel_EN = "RESTAURANT";
  home_selezionaGiorno_EN = "When?";
  homeCena_EN = "Dinner";
  homeNumeroCoperti_EN = "How many seats?";
  homePranzo_EN = "Lunch";
  homePranzoOCena_EN = "Do you want to book Lunch or Dinner?";
  homePrenotaLabel_EN = "Book it";
  homeScegliNumeroCoperti_EN = "Please choose the nr. of seats";
  homeSelezionaOrario_EN = "Select the time";
  homeSelezionaOrarioMsg_EN = "Please, select the time";
  homeServizioBar_EN = "The service will be available as soon as possible.";
  infoAccessLabel_EN = "Accessibility";
  infoComunicazioniLabel_EN = "For any further info write to ";
  infoCusciniLabel_EN = "Cushions For";
  infoDocceLabel_EN = "Showers";
  infoFilaLabel_EN = "Row";
  infoLabel_EN = "Info";
  infonNoleggioLabel_EN = "Rental";
  infoParcheggioLabel_EN = "Parking";
  infoPrezziLabel_EN = "Prices";
  infoRistoranteLabel_EN = "Restaurant";
  infoServiziLabel_EN = "Our Services";
  inPreparazioneLabel_EN = "available soon";
  inserisciDatiLabel_EN = "Choose your umbrella:";
  insertName_EN = "Please insert your name";
  insertSurname_EN = "Please insert your surname";
  invalidPhone_EN = "Wrong phone number";
  isCarrelloIbridoLabel_EN = "YOU CAN'T BUY SERVICES, DRINKS AND UMBRELLAS AT THE SAME TIME, PLEASE PAY ONE CATEGORY AT A TIME";
  lettinoAggiuntivoLabel_EN = "Additional Sea Bed";
  lettinoLabel_EN = "SEA BED";
  listaCaniLabel_EN = "Dogs list:";
  listaOrdiniLabel_EN = "Orders";
  lunghMaxDodCar_EN = "Max length 12 characters";
  lunghMaxVentiCar_EN = "Max length 20 characters";
  lunghMaxVentiCinqueCar_EN = "Max length 25 characters";
  lunghMinDueCar_EN = "Min length 2 characters";
  lunghMinSeiCar_EN = "Min length 6 characters";
  lunghMinTreCar_EN = "Min length 3 characters";
  mattinaLabel_EN = "Morning";
  maxPostiPren_EN = "Available seats:";
  menuDelGiornoLabel_EN = "Today's special";
  menuPubblicoChiudiLabel_EN = "GO BACK";
  modificaProfiloLabel_EN = "Edit Profile";
  monthLongNames_EN = "January, February, March, April, May, June, July, August, September, October, November, December";
  nessunoLabel_EN = "NOTHING";
  nessunOrdineLabel_EN = "You have no orders";
  nienteSdraioLabel_EN = "There are no sea beds available.";
  nomeCaneDue_EN = "Dog Two:";
  nomeCaneUno_EN = "Dog One:";
  numeroCopertiLabel_EN = "Seats:";
  numeroLettiniLabel_EN = "Beds:";
  numeroSdraioLabel_EN = "Deck chairs:";
  numeroSeduteLabel_EN = "Nr. of seats";
  numeroServiziAggLabel_EN = "Additional services: ";
  obbligoDueSdraioLabel_EN = "You must book at least 2 sea beds.";
  obbligoUnaSdraioLabel_EN = "You must book at least 1 sea bed.";
  ombrelloneLabel_EN = "Beach Umbrella";
  onlyLetters_EN = "Enter letters only";
  onlyNumbers_EN = "Enter numbers only";
  ordineEffettuatoLabel_EN = "Shopping list ";
  ordineNrLabel_EN = "Booking Nr.";
  pomeriggioLabel_EN = "Afternoon";
  posizioneLabel_EN = "Position:";
  postiDisp_EN = "There are no seats available.";
  pranzoCena_EN = "Lunch or Dinner?";
  prenotaPostoLabel_EN = "Book an Umbrella";
  prenotaTabBar_EN = "Book";
  prenotazioneLabel_EN = "Lunch or Dinner?"
  proseguiGuestLabel_EN = "Continue as a guest";
  resetPass_cambiaPassword_EN = "Change Password";
  resetPass_confermaCambioLabel_EN = "You will get a confirmation email";
  resetPass_diversePassword_EN = "The passwords are different";
  resetPass_emailNonValida_EN = "Invalid E-mail address";
  resetPass_inserireMail_EN = "Please insert your E-mail address";
  resetPass_inserirePassword_EN = "Please, choose a password";
  resetPass_inserisciDatiLabel_EN = "Enter your data to reset the password:";
  resetPass_modificaLabel_EN = "Password Reset";
  resetPass_msgConfermaLabel_EN = "Click on the confirmation email to log in with the new password ";
  resetPass_reinserirePassword_EN = "Please, re-enter the password";
  resetPass_riscriviLabel_EN = "Re-Enter";
  resetPass_spamLabel_EN = "(Check junk mail)";
  riepilogoLabel_EN = "Order summary";
  ristorante_confermaLabel_EN = "Book it";
  ristorante_disponibiliLabel_EN = "Available:";
  ristorante_postiLabel_EN = "Seats";
  ristoranteLabel_EN = "Restaurant";
  scegliDataLabel_EN = "Please, pick a date";
  scegliOmbrelloLabel_EN = "Choose an Umbrella";
  sdraioAggiuntivaLabel_EN = "Additional Deck Chair";
  sdraioAggLabel_EN = "DECK CHAIR";
  sdraioLabel_EN = "Deck chairs:";
  seduteAggLabel_EN = "ADDITIONAL SEA BEDS";
  signup_account_EN = "Account Creation";
  signup_cognome_EN = "Surname";
  signup_completa_messDati_EN = "To proceed enter all the data requested."
  signup_completaRegistrazione_EN = "Complete Registration";
  signup_emailNonValida_EN = "Invalid E-mail address";
  signup_inserireMail_EN = "Please insert your E-mail address";
  signup_inserirePassword_EN = "Please, choose a password";
  signup_inserireTelefono_EN = "Please insert your Phone number";
  signup_nome_EN = "Name";
  signup_presoVisioneInformativa_EN = "I have read the information on personal <br> data processing";
  signup_presoVisioneTrattamento_EN = "I have read the information on the Purpose <br> of the data processing";
  signup_telefono_EN = "Phone";
  tagliaCaneLabel_EN = "Dog Size";
  tagliaGrandeLabel_EN = "Large";
  tagliaPiccolaLabel_EN = "Small";
  totaleLabel_EN = "Total:"
  totaleParzialeLabel_EN = "Subtotal:";
  trattametoDati_EN = "Personal Data Processing";
  verificaDispLabel_EN = "Check Availability";
  viaggiaConCaniLabel_EN = "Do you have dogs?";
  viaggiaConCaniSiLabel_EN = "Yes";
  welcome_emailNonValida_EN = "Invalid E-mail address";
  welcome_fbLogin_EN = "Facebook Login";
  welcome_inserireMail_EN = "Please insert your E-mail address";
  welcome_inserirePassword_EN = "Please, choose a password";
  welcome_passDimenticata_EN = "Forgot Password?";
  welcome_registrati_EN = "Signup";
  richiesteParticolariLabel_EN = "Add any special requests...";
  costoCopertoLabel_EN = "Cover charge is € 2 per person";
  garanziaPrenotazioneRistoranteLabel_EN = "Reservations are guaranteed up to 15 minutes after the booked time. In case of a longer delay, the reservation may no longer be guaranteed.";

  /* FINE LINGUA INGLESE */

  /* LINGUA FRANCESE */
  appUpdateLabel_FR = "Update App";
  ordineInGestioneLabel_FR = "Commande en préparation";
  ordineProntoLabel_FR = "Votre commande est prête";
  ordineNonProntoLabel_FR = "Votre commande n'est pas encore prête";
  prenotaAsportoLabel_FR = "la réservation est pour aujourd'hui";
  accessoriExtraGazeboLabel_FR = "1 Chaise de cinéma 1 Hamac 1 Table";
  sdraioSingolaLabel_FR = "Chaise longues";
  sdraioMultipleLabel_FR = "Chaises longues";
  lettinoSingoloLabel_FR = "Lit de plage";
  lettiniMultipliLabel_FR = "Lits de plage";
  aggiornaDatiLabel_FR = "Update le profil";
  aggiungiCarrelloLabel_FR = "Ajouter au panier";
  alDateLabel_FR = "Au";
  alertAppObsoleta_FR = "La version de votre application est obsolète";
  alertAppObsoletaMess_FR = "Veuillez mettre à jour l'application si vous souhaitez l'utiliser. Dans certains cas, il peut être nécessaire de désinstaller l'ancienne version et d'installer la dernière version disponible sur le store.";
  alertAppInAggiornamento_FR = "Application en maintenance";
  alertAppInAggiornamentoMess_FR = "Nous nous excusons pour le dérangement";
  alertDopoLeDodiciLabel_FR = "Vous ne pouvez réserver que pour le dîner ou pour les prochains jours";
  alertDopoLeUndiciLabel_FR = "Après 11h, vous ne pouvez réserver que pour les prochains jours";
  alertDopoLeVentiLabel_FR = "Vous ne pouvez réserver que pour d'autres jours";
  alertDopoLeOttoLabel_FR = "Après 18h00, il n'est pas possible de faire des réservations pour le jour même. Vous ne pouvez réserver que pour les prochains jours";
  alertError_FR = "Oups! Quelque chose d'horrible est arrivé!";
  alertErroreDateLabel_FR = "La date de fin ne peut pas être inférieure à la date de début";
  alertErroreLabel_FR = "Erreur de sélection de date";
  alertErrorMessage_FR = "Réessayez :) Si l'erreur persiste, déconnectez-vous et réessayez s'il vous plaît";
  alertGiorniPassatiLabel_FR = "Il n'est pas possible de réserver pour des jours passés";
  alertLetturaDati_FR = "Lecture des données ...";
  alertMaxOmbrelloni_FR = "Vous pouvez réserver jusqu'à 5 parasols à la fois."
  alertOmbrNonDispLabel_FR = "Le parasol sélectionné n'est plus disponible, choisissez-en un autre.";
  alertPagamentoInCorso_FR = "Paiement...";
  alertPrenotaOmbrellone_FR = "Réservation de parasol ";
  alertPrenotaRistorante_FR = "Réservation de restaurant";
  alertSalvataggioInCorso_FR = "Sauvegarde des données...";
  alertTempoScaduto_FR = "Délai de réservation écoulé: le panier est vidé.";
  alertUtentePassErrati_FR = "E-mail ou mot de passe incorrect";
  alertUtentePassRiprovare_FR = "Vérifiez les données saisies et réessayez.";
  annullaLabel_FR = "Annuler";
  avantiLabel_FR = "PROCÉDER";
  barSpiaggiaLabel_FR = "Ordres de plage";
  calcoloPrezzoLabel_FR = "Calcul du prix ...";
  carrelloLabel_FR = "Aller au panier";
  ordineMinimoLabel_FR = "La commande minimum est de €{importo}";
  cartaCredito_aggiungiCartaLabel_FR = "Ajouter une carte";
  cartaCredito_aggiungiCartaPagamentoLabel_FR = "AJOUTER OU MODIFIER UNE CARTE";
  cartaCredito_cambiaCartaLabel_FR = "Changer la carte";
  cartaCredito_cartaLabel_FR = "Carte";
  cartaCredito_consegnaLabel_FR = "Livraison: ";
  cartaCredito_errorMsgLabel_FR = "Nous sommes désolés, quelque chose n'a pas fonctionné.";
  cartaCredito_esitoPagamentoLabel_FR = "Résultat du paiement";
  cartaCredito_modificaCartaLabel_FR = "Modifier la carte de crédit";
  cartaCredito_modificaCartaPagamentoLabel_FR = "Modifier la carte de paiement";
  cartaCredito_nessunaCartaLabel_FR = "Aucune carte disponible";
  cartaCredito_numeroCartaLabel_FR = "Numéro de carte";
  cartaCredito_ordineCompletatoLabel_FR = "COMMANDE TERMINÉE";
  cartaCredito_ordineMsgLabel_FR = "Le parasol doit être occupé à midi";
  cartaCredito_pagaConCartaLabel_FR = "Payez avec une carte de crédit";
  cartaCredito_pagaOraLabel_FR = "PAYEZ MAINTENANT";
  cartaCredito_rimuoviCartaLabel_FR = "Retirer la carte";
  cartaCredito_ritentaOrdineLabel_FR = "RÉESSAYER";
  cartaCredito_scadenzaCartaLabel_FR = "Expiration";
  cartaCredito_tornaHomeLabel_FR = "PAGE PRINCIPALE";
  cartaCredito_totaleOrdineLabel_FR = "Total de la commande";
  checkoutCarrelloCartaCreditoLabel_FR = "Carte de crédit";
  checkoutCarrelloConcludiPagamentoLabel_FR = "Terminez le paiement";
  checkoutCarrelloConsegnaOrdineBarLabel_FR = "Où livrer votre commande?";
  checkoutCarrelloConsegnaOrdineMsgLabel_FR = "Veuillez indiquer où livrer votre commande";
  checkoutCarrelloContantiLabel_FR = "Payer à la caisse";
  checkoutCarrelloPagaDopoLabel_FR = "Payer plus tard";
  checkoutCarrelloPagaDopoDisclaimerLabel_FR = "La réservation effectuée avec \"Payer plus tard\" doit être payée depuis votre espace \"Récapitulatif des commandes\" dans les 24 heures suivant la date réservée.";
  checkoutCarrelloContinuaAcquistiLabel_FR = "Continuer vos achats";
  checkoutCarrelloDataLabel_FR = "Date:";
  checkoutCarrelloLabel_FR = "Panier";
  checkoutCarrelloMetodoPagamentoLabel_FR = "Méthode de paiement?";
  checkoutCarrelloNoPagamentoLabel_FR = "Aucun paiement requis";
  checkoutCarrelloNrLettiniLabel_FR = "Lits de plage:";
  checkoutCarrelloNrSdraioLabel_FR = "Chaises longues:";
  checkoutCarrelloNumeroPostiRistoranteLabel_FR = "Nombre de places";
  checkoutCarrelloOrarioLabel_FR = "Heure:";
  checkoutCarrelloOrdineBarLabel_FR = "Bar:";
  checkoutCarrelloOrdineOmbrelloniTimeoutLabel_FR = "Commande des Parasols";
  checkoutCarrelloPagaLabel_FR = "Payer";
  checkoutCarrelloPlaceHolderConsegnaLabel_FR = "Exemple: Parasol A11";
  checkoutCarrelloPrenotatoLabel_FR = "Réservé:";
  checkoutCarrelloQuandoLabel_FR = "Quand:";
  checkoutCarrelloRistoranteLabel_FR = "Réservation au restaurant:";
  checkoutCarrelloSvuotaCarrelloLabel_FR = "Videz le panier";
  checkoutCarrelloTotaleLabel_FR = "Total:";
  checkoutCarrelloVuotoLabel_FR = "Le panier est vide.";
  ciaoUserLabel_FR = "Salut";
  confermaLabel_FR = "Confirmer";
  confermaOmbrellone_Label_FR = "Confirmez votre réservation";
  confermaRistorante_Label_FR = "Confirmez votre réservation";
  dalDateLabel_FR = "Du";
  dataLabel_FR = "Date:";
  dayNamesLabel_FR = "Dimanche -, Lundi -,  Mardi-,  Mercredi-, Jeudi -, Vendredi -, Samedi -";
  dogLabel_FR = "Les chiens sont les bienvenus";
  fasciaOrariaLabel_FR = "Créneau horaire";
  finalitaTrattamento_FR = "Objectif du traitement des données";
  giornataLabel_FR = "Toute la journée";
  giorniMultipliLabel_FR = "Plusieurs jours";
  giorniPrenotatiLabel_FR = "Jours réservés:";
  hoDueCaniLabel_FR = "J'ai deux chiens";
  home_dataDifferente_FR = "Choisissez une autre date";
  home_dayNames_FR = "Dim -, Lun -, Mar -, Mer -, Jeu -, Ven -, Sam -";
  home_disponibiliLabel_FR = "Disponibles:";
  home_monthShortNames_FR = "Jan, Fév, Mar, Avr, Mai, Jun, Jul, Aou, Sep, Oct, Nov, Déc";
  home_postiLabel_FR = "Sièges";
  home_prenotaOmbrellone_FR = "Réservez un parasol";
  home_prenotaOnline_FR = "Réservation online";
  home_prenotaRistorante_FR = "Réservez le restaurant"
  home_ristoranteLabel_FR = "RESTAURANT";
  home_selezionaGiorno_FR = "Quand?";
  homeCena_FR = "Dîner";
  homeNumeroCoperti_FR = "Combien de sièges?";
  homePranzo_FR = "Le déjeuner";
  homePranzoOCena_FR = "Réserver pour le déjeuner ou le dîner?";
  homePrenotaLabel_FR = "Réserver";
  homeScegliNumeroCoperti_FR = "Veuillez choisir le nr. de sièges";
  homeSelezionaOrario_FR = "Sélectionnez l'heure";
  homeSelezionaOrarioMsg_FR = "Veuillez sélectionner l'heure";
  homeServizioBar_FR = "Le service sera disponible dès que possible";
  infoAccessLabel_FR = "Accessibilité";
  infoComunicazioniLabel_FR = "Pour toute information complémentaire, écrivez à ";
  infoCusciniLabel_FR = "Coussins pour";
  infoDocceLabel_FR = "Douches";
  infoFilaLabel_FR = "Rangée";
  infoLabel_FR = "Info";
  infonNoleggioLabel_FR = "Location";
  infoParcheggioLabel_FR = "Parking";
  infoPrezziLabel_FR = "Prix";
  infoRistoranteLabel_FR = "Restaurant";
  infoServiziLabel_FR = "Nos services";
  inPreparazioneLabel_FR = "Bientôt disponible";
  inserisciDatiLabel_FR = "Choisissez votre parasol";
  insertName_FR = "Veuillez insérer votre nom";
  insertSurname_FR = "Veuillez insérer votre nom de famille";
  invalidPhone_FR = "Mauvais numéro de téléphone";
  isCarrelloIbridoLabel_FR = "VOUS NE POUVEZ PAS ACHETER DES SERVICES, DES BOISSONS ET DES PARAPLUIES EN MÊME TEMPS, VEUILLEZ PAYER UNE CATÉGORIE À LA FOIS";
  lettinoAggiuntivoLabel_FR = "Lits de plage supplémentaires";
  lettinoLabel_FR = "LIT DE PLAGE";
  listaCaniLabel_FR = "Liste des chiens:";
  listaOrdiniLabel_FR = "Commande";
  lunghMaxDodCar_FR = "Longueur max 12 caractères";
  lunghMaxVentiCar_FR = "Longueur max 20 caractères";
  lunghMaxVentiCinqueCar_FR = "Longueur max 25 caractères";
  lunghMinDueCar_FR = "Longueur min 2 caractères";
  lunghMinSeiCar_FR = "Longueur min 6 caractères";
  lunghMinTreCar_FR = "Longueur min 3 caractères";
  mattinaLabel_FR = "Matin";
  maxPostiPren_FR = "Places libres:";
  menuDelGiornoLabel_FR = "Le plat du jour";
  menuPubblicoChiudiLabel_FR = "RETOURNER";
  modificaProfiloLabel_FR = "Editer le profil";
  monthLongNames_FR = "Janvier, Février, Mars, Avril, Mai, Juin, Juillet, Août, Septembre, Octobre, Novembre, Décembre";
  nessunoLabel_FR = "RIEN";
  nessunOrdineLabel_FR = "Vous n'avez aucune commande";
  nienteSdraioLabel_FR = "Il n'y a pas de lits de plage disponibles.";
  nomeCaneDue_FR = "Chien Deux:";
  nomeCaneUno_FR = "Chien Un:";
  numeroCopertiLabel_FR = "Sièges:";
  numeroLettiniLabel_FR = "Lits de plage:";
  numeroSdraioLabel_FR = "Chaises longues:";
  numeroSeduteLabel_FR = "Nr. de sièges";
  numeroServiziAggLabel_FR = "Services supplémentaires:";
  obbligoDueSdraioLabel_FR = "Vous devez réserver au moins 2 lits de plage";
  obbligoUnaSdraioLabel_FR = "Vous devez réserver au moins 1 lit de plage";
  ombrelloneLabel_FR = "Parasol";
  onlyLetters_FR = "Lettres seulement";
  onlyNumbers_FR = "Chiffres uniquement";
  ordineEffettuatoLabel_FR = "Shopping liste ";
  ordineNrLabel_FR = "Réservation Nr.";
  pomeriggioLabel_FR = "Après midi";
  posizioneLabel_FR = "Position:";
  postiDisp_FR = "Il n'y a pas de places disponibles.";
  pranzoCena_FR = "Déjeuner ou dîner?";
  prenotaPostoLabel_FR = "Réservez un parasol";
  prenotaTabBar_FR = "Réserver";
  prenotazioneLabel_FR = "Déjeuner ou dîner?";
  proseguiGuestLabel_FR = "Continuer en tant que visiteur";
  resetPass_cambiaPassword_FR = "Changer le mot de passe";
  resetPass_confermaCambioLabel_FR = "Vous recevrez un email de confirmation";
  resetPass_diversePassword_FR = "Les mots de passe sont différents";
  resetPass_emailNonValida_FR = "Adresse e-mail invalide";
  resetPass_inserireMail_FR = "Veuillez insérer votre adresse e-mail";
  resetPass_inserirePassword_FR = "Veuillez choisir un mot de passe";
  resetPass_inserisciDatiLabel_FR = "Entrez vos données pour réinitialiser le mot de passe:";
  resetPass_modificaLabel_FR = "Réinitialisation du mot de passe";
  resetPass_msgConfermaLabel_FR = "Cliquez sur l'e-mail de confirmation pour vous connecter avec le nouveau mot de passe ";
  resetPass_reinserirePassword_FR = "Veuillez retaper le mot de passe";
  resetPass_riscriviLabel_FR = "Retaper";
  resetPass_spamLabel_FR = "(Vérifiez le courrier indésirable)";
  riepilogoLabel_FR = "Récapitulatif de la commande";
  ristorante_confermaLabel_FR = "Réserver";
  ristorante_disponibiliLabel_FR = "Disponible:";
  ristorante_postiLabel_FR = "Places";
  ristoranteLabel_FR = "Restaurant";
  scegliDataLabel_FR = "Veuillez choisir une date";
  scegliOmbrelloLabel_FR = "Choisissez un parasol";
  sdraioAggiuntivaLabel_FR = "Chaise longue supplémentaire";
  sdraioAggLabel_FR = "CHAISE LONGUE";
  sdraioLabel_FR = "Chaises longues:";
  seduteAggLabel_FR = "LITS DE MER SUPPLÉMENTAIRES";
  signup_account_FR = "Enregistrement";
  signup_cognome_FR = "Nom de famille";
  signup_completa_messDati_FR = "Pour continuer, entrez toutes les données demandées."
  signup_completaRegistrazione_FR = "Terminer l'inscription";
  signup_emailNonValida_FR = "Adresse e-mail invalide";
  signup_inserireMail_FR = "Veuillez insérer votre adresse e-mail";
  signup_inserirePassword_FR = "Veuillez choisir un mot de passe";
  signup_inserireTelefono_FR = "Veuillez insérer votre numéro de téléphone";
  signup_nome_FR = "Nom";
  signup_presoVisioneInformativa_FR = "J'ai lu les informations sur le traitement <br> des données personnelles";
  signup_presoVisioneTrattamento_FR = "J'ai lu les informations sur la finalité <br> du traitement des données";
  signup_telefono_FR = "Téléphone";
  tagliaCaneLabel_FR = "Taille du chien";
  tagliaGrandeLabel_FR = "Grand";
  tagliaPiccolaLabel_FR = "Petit";
  totaleLabel_FR = "Total:"
  totaleParzialeLabel_FR = "Subtotal:";
  trattametoDati_FR = "Traitement des données personnelles";
  verificaDispLabel_FR = "Voir la disponibilité";
  viaggiaConCaniLabel_FR = "Avez-vous des chiens?";
  viaggiaConCaniSiLabel_FR = "Oui";
  welcome_emailNonValida_FR = "Adresse e-mail invalide";
  welcome_fbLogin_FR = "Facebook Login";
  welcome_inserireMail_FR = "Veuillez insérer votre adresse e-mail";
  welcome_inserirePassword_FR = "Veuillez choisir un mot de passe";
  welcome_passDimenticata_FR = "Mot de passe oublié?";
  welcome_registrati_FR = "S'inscrire";
  richiesteParticolariLabel_FR = "Ajouter des demandes spéciales...";
  costoCopertoLabel_FR = "Le couvert est de 2 € par personne";
  garanziaPrenotazioneRistoranteLabel_FR = "Les réservations sont garanties jusqu'à 15 minutes après l'horaire réservé. En cas de retard supérieur, la réservation pourrait ne plus être garantie.";

  /* FINE LINGUA FRANCESE */

  /* LINGUA OLANDESE */
  appUpdateLabel_NL = "Update App";
  ordineInGestioneLabel_NL = "Bestelling in behandeling";
  ordineProntoLabel_NL = "Uw bestelling is klaar";
  ordineNonProntoLabel_NL = "Uw bestelling is nog niet klaar";
  prenotaAsportoLabel_NL = "Direct naar parasol ontvangen";
  accessoriExtraGazeboLabel_NL = "1 Regisseursstoel 1 Hangmat 1 Tafel";
  sdraioSingolaLabel_NL = "Ligstoel";
  sdraioMultipleLabel_NL = "Ligstoelen";
  lettinoSingoloLabel_NL = "Strandbedstoel";
  lettiniMultipliLabel_NL = "Strandbedstoelen";
  aggiornaDatiLabel_NL = "Profiel bijwerken";
  aggiungiCarrelloLabel_NL = "Toevoegen aan winkelwagen";
  alDateLabel_NL = "Tot:";
  alertAppObsoleta_NL = "Uw app-versie is verouderd";
  alertAppObsoletaMess_NL = "Werk de app bij als u deze wilt gebruiken. In sommige gevallen kan het nodig zijn om de oude versie te verwijderen en de nieuwste versie uit de store te installeren.";
  alertAppInAggiornamento_NL = "Applicatie in onderhoud";
  alertAppInAggiornamentoMess_NL = "Onze excuses voor het ongemak";
  alertDopoLeDodiciLabel_NL = "U kunt alleen reserveren voor diner of voor de volgende dagen";
  alertDopoLeUndiciLabel_NL = "Na 11:00 uur kunt u alleen nog reserveren voor de volgende dagen";
  alertDopoLeVentiLabel_NL = "U kunt alleen voor andere dagen reserveren";
  alertDopoLeOttoLabel_NL = "Na 18:00 uur is het niet mogelijk om reserveringen te maken voor de huidige dag. U kunt alleen reserveren voor de volgende dagen";
  alertError_NL = "Oeps! Er is iets mis gegaan!";
  alertErroreDateLabel_NL = "De einddatum kan niet eerder zijn dan de startdatum";
  alertErroreLabel_NL = "Fout bij datumkeuze";
  alertErrorMessage_NL = "Probeer opnieuw :) Als de fout aanhoudt, log dan uit en probeer opnieuw";
  alertGiorniPassatiLabel_NL = "U kunt niet in het verleden boeken :)";
  alertLetturaDati_NL = "Gegevens worden gelezen...";
  alertMaxOmbrelloni_NL = "U kunt maximaal 5 parasols tegelijk reserveren."
  alertOmbrNonDispLabel_NL = "De geselecteerde parasol is niet meer beschikbaar, kies een ander.";
  alertPagamentoInCorso_NL = "Betaling bezig...";
  alertPrenotaOmbrellone_NL = "Parasol reservering";
  alertPrenotaRistorante_NL = "Restaurantreservering";
  alertSalvataggioInCorso_NL = "Gegevens worden opgeslagen...";
  alertTempoScaduto_NL = "Reserveringstijd verlopen: de winkelwagen is leeggemaakt.";
  alertUtentePassErrati_NL = "Onjuist e-mailadres of wachtwoord";
  alertUtentePassRiprovare_NL = "Controleer de ingevoerde gegevens en probeer opnieuw.";
  annullaLabel_NL = "Annuleren";
  avantiLabel_NL = "DOORGAAN";
  barSpiaggiaLabel_NL = "Strandbestellingen";
  calcoloPrezzoLabel_NL = "Prijsberekening bezig...";
  carrelloLabel_NL = "Ga naar winkelwagen";
  ordineMinimoLabel_NL = "De minimale bestelling is €{importo}";
  cartaCredito_aggiungiCartaLabel_NL = "Kaart toevoegen";
  cartaCredito_aggiungiCartaPagamentoLabel_NL = "KAART TOEVOEGEN OF WIJZIGEN";
  cartaCredito_cambiaCartaLabel_NL = "Kaart wijzigen";
  cartaCredito_cartaLabel_NL = "Kaart";
  cartaCredito_consegnaLabel_NL = "Bezorging: ";
  cartaCredito_errorMsgLabel_NL = "Ons spijt het, er is iets misgegaan.";
  cartaCredito_esitoPagamentoLabel_NL = "Betalingsresultaat";
  cartaCredito_modificaCartaLabel_NL = "Creditcard wijzigen";
  cartaCredito_modificaCartaPagamentoLabel_NL = "Betaalkaart wijzigen";
  cartaCredito_nessunaCartaLabel_NL = "Geen kaarten beschikbaar";
  cartaCredito_numeroCartaLabel_NL = "Kaartnummer";
  cartaCredito_ordineCompletatoLabel_NL = "BESTELLING VOLTOOID";
  cartaCredito_ordineMsgLabel_NL = "De strandparasol moet voor het middaguur in bezit zijn";
  cartaCredito_pagaConCartaLabel_NL = "Betalen met creditcard";
  cartaCredito_pagaOraLabel_NL = "NU BETALEN";
  cartaCredito_rimuoviCartaLabel_NL = "Kaart verwijderen";
  cartaCredito_ritentaOrdineLabel_NL = "OPNIEUW PROBEREN";
  cartaCredito_scadenzaCartaLabel_NL = "Vervaldatum";
  cartaCredito_tornaHomeLabel_NL = "GA NAAR HOME";
  cartaCredito_totaleOrdineLabel_NL = "Totale bestelling";
  checkoutCarrelloCartaCreditoLabel_NL = "Creditcard";
  checkoutCarrelloConcludiPagamentoLabel_NL = "Betaling voltooien";
  checkoutCarrelloConsegnaOrdineBarLabel_NL = "Waar uw bestelling bezorgen?";
  checkoutCarrelloConsegnaOrdineMsgLabel_NL = "Voer in waar uw bestelling moet worden bezorgd";
  checkoutCarrelloContantiLabel_NL = "Betaal aan de kassa";
  checkoutCarrelloPagaDopoLabel_NL = "Later betalen";
  checkoutCarrelloPagaDopoDisclaimerLabel_NL = "De reservering met \"Later betalen\" moet binnen 24 uur vanaf de gereserveerde datum worden betaald via het gedeelte \"Besteloverzicht\".";
  checkoutCarrelloContinuaAcquistiLabel_NL = "Winkelen voortzetten";
  checkoutCarrelloDataLabel_NL = "Datum:";
  checkoutCarrelloLabel_NL = "Winkelwagen";
  checkoutCarrelloMetodoPagamentoLabel_NL = "Selecteer een betaalmethode:";
  checkoutCarrelloNoPagamentoLabel_NL = "Geen betaling nodig";
  checkoutCarrelloNrLettiniLabel_NL = "Aantal strandbedstoelen:";
  checkoutCarrelloNrSdraioLabel_NL = "Aantal ligstoelen:";
  checkoutCarrelloNumeroPostiRistoranteLabel_NL = "Aantal zitplaatsen:";
  checkoutCarrelloOrarioLabel_NL = "Uur:";
  checkoutCarrelloOrdineBarLabel_NL = "Barbestelling:";
  checkoutCarrelloOrdineOmbrelloniTimeoutLabel_NL = "Parasol bestelling";
  checkoutCarrelloPagaLabel_NL = "Betalen";
  checkoutCarrelloPlaceHolderConsegnaLabel_NL = "Voorbeeld: Parasol A11";
  checkoutCarrelloPrenotatoLabel_NL = "Gereserveerd:";
  checkoutCarrelloQuandoLabel_NL = "Wanneer:";
  checkoutCarrelloRistoranteLabel_NL = "Restaurantreservering:";
  checkoutCarrelloSvuotaCarrelloLabel_NL = "Winkelwagen legen";
  checkoutCarrelloTotaleLabel_NL = "Totaal:";
  checkoutCarrelloVuotoLabel_NL = "De winkelwagen is leeg.";
  ciaoUserLabel_NL = "Hallo";
  confermaLabel_NL = "Bevestigen";
  confermaOmbrellone_Label_NL = "Bevestig uw reservering";
  confermaRistorante_Label_NL = "Bevestig uw reservering";
  dalDateLabel_NL = "Van:";
  dataLabel_NL = "Datum:";
  dayNamesLabel_NL = "Zondag -, Maandag -, Dinsdag -, Woensdag -, Donderdag -, Vrijdag -, Zaterdag -";
  dogLabel_NL = "Honden zijn welkom";
  fasciaOrariaLabel_NL = "Tijdslot";
  finalitaTrattamento_NL = "Doel van gegevensverwerking";
  giornataLabel_NL = "Hele dag";
  giorniMultipliLabel_NL = "Meerdere dagen";
  giorniPrenotatiLabel_NL = "Geboekte dagen:";
  hoDueCaniLabel_NL = "Ik heb twee honden";
  home_dataDifferente_NL = "Kies een andere datum";
  home_dayNames_NL = "Zon -, Maa -, Din -, Woe -, Don -, Vri -, Zat -";
  home_disponibiliLabel_NL = "Beschikbaar:";
  home_monthShortNames_NL = "Jan, Feb, Maa, Apr, Mei, Jun, Jul, Aug, Sep, Okt, Nov, Dec";
  home_postiLabel_NL = "Zitplaatsen";
  home_prenotaOmbrellone_NL = "Reserveer een parasol";
  home_prenotaOnline_NL = "Online reserveren";
  home_prenotaRistorante_NL = "Reserveer het restaurant"
  home_ristoranteLabel_NL = "RESTAURANT";
  home_selezionaGiorno_NL = "Wanneer?";
  homeCena_NL = "Diner";
  homeNumeroCoperti_NL = "Hoeveel zitplaatsen?";
  homePranzo_NL = "Lunch";
  homePranzoOCena_NL = "Wilt u lunch of diner reserveren?";
  homePrenotaLabel_NL = "Reserveer het";
  homeScegliNumeroCoperti_NL = "Kies het aantal zitplaatsen";
  homeSelezionaOrario_NL = "Selecteer de tijd";
  homeSelezionaOrarioMsg_NL = "Selecteer alstublieft de tijd";
  homeServizioBar_NL = "De service zal zo snel mogelijk beschikbaar zijn.";
  infoAccessLabel_NL = "Toegankelijkheid";
  infoComunicazioniLabel_NL = "Voor meer informatie, schrijf naar ";
  infoCusciniLabel_NL = "Kussens voor";
  infoDocceLabel_NL = "Douches";
  infoFilaLabel_NL = "Rij";
  infoLabel_NL = "Info";
  infonNoleggioLabel_NL = "Verhuur";
  infoParcheggioLabel_NL = "Parkeren";
  infoPrezziLabel_NL = "Prijzen";
  infoRistoranteLabel_NL = "Restaurant";
  infoServiziLabel_NL = "Onze services";
  inPreparazioneLabel_NL = "binnenkort beschikbaar";
  inserisciDatiLabel_NL = "Voer uw gegevens in:";
  insertName_NL = "Voer uw naam in";
  insertSurname_NL = "Voer uw achternaam in";
  invalidPhone_NL = "Onjuist telefoonnummer";
  isCarrelloIbridoLabel_NL = "U KUNT NIET TEGELIJK SERVICES, DRANKJES EN PARASOLS KOPEN, BETAAL ALSTUBLIEFT EEN CATEGORIE TEGELIJK";
  lettinoAggiuntivoLabel_NL = "Extra strandbedstoel";
  lettinoLabel_NL = "STRANDBEDSTOEL";
  listaCaniLabel_NL = "Hondenlijst:";
  listaOrdiniLabel_NL = "Bestellingen";
  lunghMaxDodCar_NL = "Maximaal 12 tekens";
  lunghMaxVentiCar_NL = "Maximaal 20 tekens";
  lunghMaxVentiCinqueCar_NL = "Maximaal 25 tekens";
  lunghMinDueCar_NL = "Minimaal 2 tekens";
  lunghMinSeiCar_NL = "Minimaal 6 tekens";
  lunghMinTreCar_NL = "Minimaal 3 tekens";
  mattinaLabel_NL = "Ochtend";
  maxPostiPren_NL = "Beschikbare zitplaatsen:";
  menuDelGiornoLabel_NL = "Dagschotel";
  menuPubblicoChiudiLabel_NL = "TERUGGAAN";
  modificaProfiloLabel_NL = "Profiel bewerken";
  monthLongNames_NL = "Januari, Februari, Maart, April, Mei, Juni, Juli, Augustus, September, Oktober, November, December";
  nessunoLabel_NL = "NIETS";
  nessunOrdineLabel_NL = "U hebt geen bestellingen";
  nienteSdraioLabel_NL = "Er zijn geen strandbedstoelen beschikbaar.";
  nomeCaneDue_NL = "Hond twee:";
  nomeCaneUno_NL = "Hond één:";
  numeroCopertiLabel_NL = "Zitplaatsen:";
  numeroLettiniLabel_NL = "Bedden:";
  numeroSdraioLabel_NL = "Ligstoelen:";
  numeroSeduteLabel_NL = "Zitplaatsen";
  numeroServiziAggLabel_NL = "Extra services: ";
  obbligoDueSdraioLabel_NL = "U moet minstens 2 strandbedstoelen reserveren.";
  obbligoUnaSdraioLabel_NL = "U moet minstens 1 strandbedstoel reserveren.";
  ombrelloneLabel_NL = "Strandparasol";
  onlyLetters_NL = "Alleen letters invoeren";
  onlyNumbers_NL = "Alleen nummers invoeren";
  ordineEffettuatoLabel_NL = "Winkellijst ";
  ordineNrLabel_NL = "Reservering nr.";
  pomeriggioLabel_NL = "Middag";
  posizioneLabel_NL = "Positie:";
  postiDisp_NL = "Er zijn geen zitplaatsen beschikbaar.";
  pranzoCena_NL = "Lunch of diner?";
  prenotaPostoLabel_NL = "Reserveer een parasol";
  prenotaTabBar_NL = "Reserveer";
  prenotazioneLabel_NL = "Lunch of diner?"
  proseguiGuestLabel_NL = "Doorgaan als gast";
  resetPass_cambiaPassword_NL = "Wachtwoord wijzigen";
  resetPass_confermaCambioLabel_NL = "U ontvangt een bevestigingse-mail";
  resetPass_diversePassword_NL = "De wachtwoorden zijn verschillend";
  resetPass_emailNonValida_NL = "Ongeldig e-mailadres";
  resetPass_inserireMail_NL = "Voer alstublieft uw e-mailadres in";
  resetPass_inserirePassword_NL = "Kies alstublieft een wachtwoord";
  resetPass_inserisciDatiLabel_NL = "Voer uw gegevens in om het wachtwoord opnieuw in te stellen:";
  resetPass_modificaLabel_NL = "Wachtwoord opnieuw instellen";
  resetPass_msgConfermaLabel_NL = "Klik op de bevestigingse-mail om in te loggen met het nieuwe wachtwoord ";
  resetPass_reinserirePassword_NL = "Voer alstublieft het wachtwoord opnieuw in";
  resetPass_riscriviLabel_NL = "Opnieuw invoeren";
  resetPass_spamLabel_NL = "(Controleer ongewenste e-mail)";
  riepilogoLabel_NL = "Bestellingsoverzicht";
  ristorante_confermaLabel_NL = "Reserveer het";
  ristorante_disponibiliLabel_NL = "Beschikbaar:";
  ristorante_postiLabel_NL = "Zitplaatsen";
  ristoranteLabel_NL = "Restaurant";
  scegliDataLabel_NL = "Kies alstublieft een datum";
  scegliOmbrelloLabel_NL = "Kies een parasol";
  sdraioAggiuntivaLabel_NL = "Extra ligstoel";
  sdraioAggLabel_NL = "LIGSTOEL";
  sdraioLabel_NL = "Ligstoelen:";
  seduteAggLabel_NL = "EXTRA STRANDBEDSTOELEN";
  signup_account_NL = "Account aanmaken";
  signup_cognome_NL = "Achternaam";
  signup_completa_messDati_NL = "Voer alstublieft alle gevraagde gegevens in."
  signup_completaRegistrazione_NL = "Registratie voltooien";
  signup_emailNonValida_NL = "Ongeldig e-mailadres";
  signup_inserireMail_NL = "Voer alstublieft uw e-mailadres in";
  signup_inserirePassword_NL = "Kies alstublieft een wachtwoord";
  signup_inserireTelefono_NL = "Voer alstublieft uw telefoonnummer in";
  signup_nome_NL = "Naam";
  signup_presoVisioneInformativa_NL = "Ik heb de informatie over verwerking van <br> persoonlijke gegevens gelezen";
  signup_presoVisioneTrattamento_NL = "Ik heb de informatie over het doel <br> van gegevensverwerking gelezen";
  signup_telefono_NL = "Telefoon";
  tagliaCaneLabel_NL = "Hondengrootte";
  tagliaGrandeLabel_NL = "Groot";
  tagliaPiccolaLabel_NL = "Klein";
  totaleLabel_NL = "Totaal:"
  totaleParzialeLabel_NL = "Subtotaal:";
  trattametoDati_NL = "Verwerking persoonlijke gegevens";
  verificaDispLabel_NL = "Beschikbaarheid controleren";
  viaggiaConCaniLabel_NL = "Hebt u honden?";
  viaggiaConCaniSiLabel_NL = "Ja";
  welcome_emailNonValida_NL = "Ongeldig e-mailadres";
  welcome_fbLogin_NL = "Facebook login";
  welcome_inserireMail_NL = "Voer alstublieft uw e-mailadres in";
  welcome_inserirePassword_NL = "Kies alstublieft een wachtwoord";
  welcome_passDimenticata_NL = "Wachtwoord vergeten?";
  welcome_registrati_NL = "Registreren";
  richiesteParticolariLabel_NL = "Voeg speciale verzoeken toe...";
  costoCopertoLabel_NL = "De servicekosten bedragen € 2 per persoon";
  garanziaPrenotazioneRistoranteLabel_NL = "Reserveringen zijn gegarandeerd tot 15 minuten na het gereserveerde tijdstip. Bij een langere vertraging kan de reservering mogelijk niet worden gegarandeerd.";
  welcome_oppure_IT = "oppure";
  welcome_oppure_EN = "or";
  welcome_oppure_FR = "ou";
  welcome_oppure_NL = "of";
  welcome_oppure_DE = "oder";
  welcome_nonHaiAccount_IT = "Non hai un account?";
  welcome_nonHaiAccount_EN = "Don't have an account?";
  welcome_nonHaiAccount_FR = "Vous n'avez pas de compte?";
  welcome_nonHaiAccount_NL = "Geen account?";
  welcome_nonHaiAccount_DE = "Noch kein Konto?";

  /* FINE LINGUA OLANDESE */

  /* Menu Profilo */
  profilo_personale_IT = "Profilo Personale";
  profilo_personale_EN = "Account";
  profilo_personale_FR = "Account";
  profilo_personale_NL = "Account";
  profilo_personale_DE = "Konto";
  trattamento_dati_personali_EN = "Personal Data Processing";
  trattamento_dati_personali_IT = "Trattamento Dati Personali";
  trattamento_dati_personali_FR = "Traitement des données personnelles";
  trattamento_dati_personali_NL = "Verwerking van persoonsgegevens";
  trattamento_dati_personali_DE = "Verarbeitung personenbezogener Daten";
  finalita_dati_personali_EN = "Purpose of data processing";
  finalita_dati_personali_IT = "Finalità Trattamento Dati";
  finalita_dati_personali_FR = "Finalité du traitement des données";
  finalita_dati_personali_NL = "Doel van gegevensverwerking";
  finalita_dati_personali_DE = "Zweck der Datenverarbeitung";
  elimina_account_IT = "Elimina Account";
  elimina_account_EN = "Delete Account";
  elimina_account_FR = "Supprimer le compte";
  elimina_account_NL = "Account verwijderen";
  elimina_account_DE = "Konto löschen";
  /* Fine Menu Profilo */

  /* Tutorial Modal */
  tutorial_benvenuto_IT = "Benvenuto!";
  tutorial_benvenuto_EN = "Welcome!";
  tutorial_benvenuto_FR = "Bienvenue!";
  tutorial_benvenuto_NL = "Welkom!";
  tutorial_benvenuto_DE = "Willkommen!";

  tutorial_salta_IT = "Salta";
  tutorial_salta_EN = "Skip";
  tutorial_salta_FR = "Passer";
  tutorial_salta_NL = "Overslaan";
  tutorial_salta_DE = "Überspringen";

  tutorial_indietro_IT = "Indietro";
  tutorial_indietro_EN = "Back";
  tutorial_indietro_FR = "Retour";
  tutorial_indietro_NL = "Terug";
  tutorial_indietro_DE = "Zurück";

  tutorial_avanti_IT = "Avanti";
  tutorial_avanti_EN = "Next";
  tutorial_avanti_FR = "Suivant";
  tutorial_avanti_NL = "Volgende";
  tutorial_avanti_DE = "Weiter";

  tutorial_inizia_IT = "Inizia";
  tutorial_inizia_EN = "Start";
  tutorial_inizia_FR = "Commencer";
  tutorial_inizia_NL = "Begin";
  tutorial_inizia_DE = "Start";

  tutorial_slide1_IT = "Benvenuto su Single Fin! Scopri come prenotare il tuo ombrellone in pochi semplici passi.";
  tutorial_slide1_EN = "Welcome to Single Fin! Discover how to book your beach umbrella in a few simple steps.";
  tutorial_slide1_FR = "Bienvenue sur Single Fin! Découvrez comment réserver votre parasol en quelques étapes simples.";
  tutorial_slide1_NL = "Welkom bij Single Fin! Ontdek hoe u in een paar eenvoudige stappen uw parasol kunt boeken.";
  tutorial_slide1_DE = "Willkommen bei Single Fin! Entdecken Sie, wie Sie Ihren Sonnenschirm in wenigen Schritten buchen.";

  tutorial_slide2_IT = "Seleziona le date del tuo soggiorno e visualizza la disponibilità degli ombrelloni.";
  tutorial_slide2_EN = "Select your stay dates and view the availability of beach umbrellas.";
  tutorial_slide2_FR = "Sélectionnez les dates de votre séjour et consultez la disponibilité des parasols.";
  tutorial_slide2_NL = "Selecteer uw verblijfdata en bekijk de beschikbaarheid van parasols.";
  tutorial_slide2_DE = "Wählen Sie Ihre Aufenthaltsdaten und sehen Sie die Verfügbarkeit der Sonnenschirme.";

  tutorial_slide3_IT = "Scegli la fascia oraria che preferisci: mattina, pomeriggio o giornata intera, aggiungi i tuoi amici a quattro zampe.";
  tutorial_slide3_EN = "Choose your preferred time slot: morning, afternoon or full day, add your four-legged friends.";
  tutorial_slide3_FR = "Choisissez votre créneau horaire préféré: matin, après-midi ou journée complète, ajoutez vos amis à quatre pattes.";
  tutorial_slide3_NL = "Kies uw voorkeurstijdslot: ochtend, middag of hele dag, voeg uw vierbenige vrienden toe.";
  tutorial_slide3_DE = "Wählen Sie Ihr bevorzugtes Zeitfenster: Vormittag, Nachmittag oder ganzer Tag, und fügen Sie Ihre Vierbeiner hinzu.";

  tutorial_slide4_IT = "Seleziona il tuo ombrellone preferito sulla mappa della spiaggia.";
  tutorial_slide4_EN = "Select your favorite beach umbrella on the beach map.";
  tutorial_slide4_FR = "Sélectionnez votre parasol préféré sur la carte de la plage.";
  tutorial_slide4_NL = "Selecteer uw favoriete parasol op de strandkaart.";
  tutorial_slide4_DE = "Wählen Sie Ihren bevorzugten Sonnenschirm auf der Strandkarte.";

  tutorial_slide5_IT = "Se viaggi con i tuoi amici a quattro zampe, assegnali al tuo ombrellone.";
  tutorial_slide5_EN = "If you travel with your four-legged friends, assign them to your beach umbrella.";
  tutorial_slide5_FR = "Si vous voyagez avec vos amis à quatre pattes, assignez-les à votre parasol.";
  tutorial_slide5_NL = "Als u met uw vierbenige vrienden reist, wijs ze dan toe aan uw parasol.";
  tutorial_slide5_DE = "Wenn Sie mit Ihren Vierbeinern reisen, ordnen Sie sie Ihrem Sonnenschirm zu.";

  tutorial_slide6_IT = "In caso di più cani, vanno assegnati ciascuno ad un ombrellone secondo la capienza massima prevista (taglia e/o numero)";
  tutorial_slide6_EN = "In case of multiple dogs, each must be assigned to a beach umbrella according to the maximum capacity (size and/or number)";
  tutorial_slide6_FR = "En cas de plusieurs chiens, chacun doit être assigné à un parasol selon la capacité maximale (taille et/ou nombre)";
  tutorial_slide6_NL = "In geval van meerdere honden moet elk worden toegewezen aan een parasol volgens de maximale capaciteit (grootte en/of aantal)";
  tutorial_slide6_DE = "Bei mehreren Hunden muss jeder entsprechend der maximalen Kapazität (Größe und/oder Anzahl) einem Sonnenschirm zugeordnet werden";

  tutorial_slide7_IT = "Rivedi il riepilogo della tua prenotazione e procedi al pagamento.";
  tutorial_slide7_EN = "Review your booking summary and proceed to payment.";
  tutorial_slide7_FR = "Consultez le récapitulatif de votre réservation et procédez au paiement.";
  tutorial_slide7_NL = "Bekijk uw boekingsoverzicht en ga verder met de betaling.";
  tutorial_slide7_DE = "Prüfen Sie die Buchungsübersicht und fahren Sie mit der Zahlung fort.";

  tutorial_slide8_IT = "Conferma la prenotazione e preparati a goderti la tua giornata al mare!";
  tutorial_slide8_EN = "Confirm your booking and get ready to enjoy your day at the beach!";
  tutorial_slide8_FR = "Confirmez votre réservation et préparez-vous à profiter de votre journée à la plage!";
  tutorial_slide8_NL = "Bevestig uw boeking en maak u klaar om te genieten van uw dag op het strand!";
  tutorial_slide8_DE = "Bestätigen Sie Ihre Buchung und genießen Sie Ihren Tag am Strand!";

  tutorial_slide9_IT = "Tutto fatto! Benvenuti al Single Fin Tuscany Beach!";
  tutorial_slide9_EN = "All done! Welcome to Single Fin Tuscany Beach!";
  tutorial_slide9_FR = "C'est fait! Bienvenue au Single Fin Tuscany Beach!";
  tutorial_slide9_NL = "Klaar! Welkom bij Single Fin Tuscany Beach!";
  tutorial_slide9_DE = "Alles erledigt! Willkommen im Single Fin Tuscany Beach!";
  /* Fine Tutorial Modal */

  /* Checkout Ombrellone */
  dettagliPrenotazioneLabel_IT = "Dettagli prenotazione";
  dettagliPrenotazioneLabel_EN = "Booking details";
  dettagliPrenotazioneLabel_FR = "Détails de la réservation";
  dettagliPrenotazioneLabel_NL = "Boekingsdetails";
  dettagliPrenotazioneLabel_DE = "Buchungsdetails";

  dataInizioLabel_IT = "Data Inizio";
  dataInizioLabel_EN = "Start Date";
  dataInizioLabel_FR = "Date de début";
  dataInizioLabel_NL = "Startdatum";
  dataInizioLabel_DE = "Startdatum";

  dataFineLabel_IT = "Data Fine";
  dataFineLabel_EN = "End Date";
  dataFineLabel_FR = "Date de fin";
  dataFineLabel_NL = "Einddatum";
  dataFineLabel_DE = "Enddatum";

  tipoPrenotazioneLabel_IT = "Tipo";
  tipoPrenotazioneLabel_EN = "Type";
  tipoPrenotazioneLabel_FR = "Type";
  tipoPrenotazioneLabel_NL = "Type";
  tipoPrenotazioneLabel_DE = "Typ";

  serviziInclusiLabel_IT = "Servizi Inclusi";
  serviziInclusiLabel_EN = "Included Services";
  serviziInclusiLabel_FR = "Services Inclus";
  serviziInclusiLabel_NL = "Inbegrepen diensten";
  serviziInclusiLabel_DE = "Inklusive Leistungen";

  assegnazioneCaniLabel_IT = "Assegnazione Cani";
  assegnazioneCaniLabel_EN = "Dog Assignment";
  assegnazioneCaniLabel_FR = "Affectation des chiens";
  assegnazioneCaniLabel_NL = "Hondentoewijzing";
  assegnazioneCaniLabel_DE = "Hundezuweisung";

  caneDaAssegnareLabel_IT = "cane da assegnare";
  caneDaAssegnareLabel_DE = "zuzuweisender Hund";
  caniDaAssegnareLabel_IT = "cani da assegnare";
  caniDaAssegnareLabel_DE = "zuzuweisende Hunde";
  caneDaAssegnareLabel_EN = "dog to assign";
  caniDaAssegnareLabel_EN = "dogs to assign";
  caneDaAssegnareLabel_FR = "chien à assigner";
  caniDaAssegnareLabel_FR = "chiens à assigner";
  caneDaAssegnareLabel_NL = "hond om toe te wijzen";
  caniDaAssegnareLabel_NL = "honden om toe te wijzen";

  taglianoncompatibileLabel_IT = "(Taglia non compatibile)";
  taglianoncompatibileLabel_EN = "(Incompatible size)";
  taglianoncompatibileLabel_FR = "(Taille incompatible)";
  taglianoncompatibileLabel_NL = "(Incompatibele maat)";
  taglianoncompatibileLabel_DE = "(Nicht kompatible Größe)";

  ombrelloneNonOspitaCaniLabel_IT = "Questo ombrellone non può ospitare cani";
  ombrelloneNonOspitaCaniLabel_EN = "This umbrella cannot accommodate dogs";
  ombrelloneNonOspitaCaniLabel_FR = "Ce parasol ne peut pas accueillir de chiens";
  ombrelloneNonOspitaCaniLabel_NL = "Deze parasol kan geen honden huisvesten";
  ombrelloneNonOspitaCaniLabel_DE = "Dieser Sonnenschirm kann keine Hunde aufnehmen";

  noteAggiuntiveLabel_IT = "Note aggiuntive";
  noteAggiuntiveLabel_EN = "Additional notes";
  noteAggiuntiveLabel_FR = "Notes supplémentaires";
  noteAggiuntiveLabel_NL = "Extra opmerkingen";
  noteAggiuntiveLabel_DE = "Zusätzliche Hinweise";

  aggiungiNoteLabel_IT = "Aggiungi qui le tue note...";
  aggiungiNoteLabel_EN = "Add your notes here...";
  aggiungiNoteLabel_FR = "Ajoutez vos notes ici...";
  aggiungiNoteLabel_NL = "Voeg hier uw notities toe...";
  aggiungiNoteLabel_DE = "Hier Ihre Hinweise eingeben...";

  attenzioneLabel_IT = "Attenzione!";
  attenzioneLabel_EN = "Attention!";
  attenzioneLabel_FR = "Attention!";
  attenzioneLabel_NL = "Attentie!";
  attenzioneLabel_DE = "Achtung!";


  capienzaSuperataTitle_IT = 'Capienza Superata';
  capienzaSuperataTitle_EN = 'Capacity Exceeded';
  capienzaSuperataTitle_FR = 'Capacité Exceeded';
  capienzaSuperataTitle_NL = 'Capaciteit overschreden';
  capienzaSuperataTitle_DE = 'Kapazität überschritten';

  capienzaSuperata_IT = 'Questo ombrellone ha raggiunto la capienza massima per i cani di questa taglia.';
  capienzaSuperata_EN = 'This umbrella has reached the maximum capacity for dogs of this size.';
  capienzaSuperata_FR = 'Ce parasol a atteint la capacité maximale pour des chiens de cette taille.';
  capienzaSuperata_NL = 'Deze parasol heeft de maximale capaciteit bereikt voor honden van deze maat.';
  capienzaSuperata_DE = 'Dieser Sonnenschirm hat die maximale Kapazität für Hunde dieser Größe erreicht.';

  assegnaTuttiICaniLabel_IT = "Devi assegnare tutti i cani agli ombrelloni prima di procedere al carrello.";
  assegnaTuttiICaniLabel_EN = "You must assign all dogs to umbrellas before proceeding to the cart.";
  assegnaTuttiICaniLabel_FR = "Vous devez assigner tous les chiens aux parasols avant de continuer au panier.";
  assegnaTuttiICaniLabel_NL = "U moet alle honden aan parasols toewijzen voordat u naar het winkelwagentje gaat.";
  assegnaTuttiICaniLabel_DE = "Sie müssen alle Hunde den Sonnenschirmen zuweisen, bevor Sie zum Warenkorb gehen.";

  deviAssegnareCaniLabel_IT = "Devi assegnare tutti i cani agli ombrelloni prima di procedere";
  deviAssegnareCaniLabel_EN = "You must assign all dogs to umbrellas before proceeding";
  deviAssegnareCaniLabel_FR = "Vous devez assigner tous les chiens aux parasols avant de continuer";
  deviAssegnareCaniLabel_NL = "U moet alle honden toewijzen aan parasols voordat u verder gaat";
  deviAssegnareCaniLabel_DE = "Sie müssen alle Hunde den Sonnenschirmen zuweisen, bevor Sie fortfahren";

  risparmioLabel_IT = "Risparmio";
  risparmioLabel_EN = "Savings";
  risparmioLabel_FR = "Économie";
  risparmioLabel_NL = "Besparing";
  risparmioLabel_DE = "Ersparnis";

  tuttiCaniAssegnatiLabel_IT = "Tutti i cani assegnati ✓";
  tuttiCaniAssegnatiLabel_EN = "All dogs assigned ✓";
  tuttiCaniAssegnatiLabel_FR = "Tous les chiens assignés ✓";
  tuttiCaniAssegnatiLabel_NL = "Alle honden toegewezen ✓";
  tuttiCaniAssegnatiLabel_DE = "Alle Hunde zugewiesen ✓";

  assegnaAutomaticamente_IT = "Assegna Automaticamente";
  assegnaAutomaticamente_EN = "Auto Assign";
  assegnaAutomaticamente_FR = "Assigner Automatiquement";
  assegnaAutomaticamente_NL = "Automatisch toewijzen";
  assegnaAutomaticamente_DE = "Automatisch zuweisen";

  impossibileAssegnareCani_IT = "Impossibile assegnare automaticamente tutti i cani. Verifica la capienza degli ombrelloni selezionati.";
  impossibileAssegnareCani_EN = "Unable to automatically assign all dogs. Check the capacity of selected umbrellas.";
  impossibileAssegnareCani_FR = "Impossible d'assigner automatiquement tous les chiens. Vérifiez la capacité des parasols sélectionnés.";
  impossibileAssegnareCani_NL = "Kan niet automatisch alle honden toewijzen. Controleer de capaciteit van geselecteerde parasols.";
  impossibileAssegnareCani_DE = "Nicht alle Hunde konnten automatisch zugewiesen werden. Prüfen Sie die Kapazität der gewählten Sonnenschirme.";

  diLabel_IT = "di";
  diLabel_EN = "of";
  diLabel_FR = "de";
  diLabel_NL = "van";
  diLabel_DE = "von";
  /* Fine Checkout Ombrellone */

  /* Ricerca Ombrellone */
  disponibileLabel_IT = "Disponibile";
  disponibileLabel_EN = "Available";
  disponibileLabel_FR = "Disponible";
  disponibileLabel_NL = "Beschikbaar";
  disponibileLabel_DE = "Verfügbar";

  occupatoLabel_IT = "Occupato";
  occupatoLabel_EN = "Occupied";
  occupatoLabel_FR = "Occupé";
  occupatoLabel_NL = "Bezet";
  occupatoLabel_DE = "Belegt";

  selezionatoLabel_IT = "Selezionato";
  selezionatoLabel_EN = "Selected";
  selezionatoLabel_FR = "Sélectionné";
  selezionatoLabel_NL = "Geselecteerd";
  selezionatoLabel_DE = "Ausgewählt";

  periodoSelezionatoLabel_IT = "PERIODO SELEZIONATO";
  periodoSelezionatoLabel_EN = "SELECTED PERIOD";
  periodoSelezionatoLabel_FR = "PÉRIODE SÉLECTIONNÉE";
  periodoSelezionatoLabel_NL = "GESELECTEERDE PERIODE";
  periodoSelezionatoLabel_DE = "AUSGEWÄHLTER ZEITRAUM";

  procediAlCheckoutLabel_IT = "PROCEDI AL CHECKOUT";
  procediAlCheckoutLabel_EN = "PROCEED TO CHECKOUT";
  procediAlCheckoutLabel_FR = "PASSER AU PAIEMENT";
  procediAlCheckoutLabel_NL = "DOORGAAN NAAR AFREKENEN";
  procediAlCheckoutLabel_DE = "ZUR KASSE WEITER";

  ombrelloniSelezionatiLabel_IT = "Ombrelloni Selezionati";
  ombrelloniSelezionatiLabel_EN = "Selected Umbrellas";
  ombrelloniSelezionatiLabel_FR = "Parasols Sélectionnés";
  ombrelloniSelezionatiLabel_NL = "Geselecteerde Parasols";
  ombrelloniSelezionatiLabel_DE = "Ausgewählte Sonnenschirme";

  tuttiLabel_IT = "Tutti";
  tuttiLabel_EN = "All";
  tuttiLabel_FR = "Tous";
  tuttiLabel_NL = "Alles";
  tuttiLabel_DE = "Alle";

  ombrelloniLabel_IT = "Ombrelloni";
  ombrelloniLabel_EN = "Umbrellas";
  ombrelloniLabel_FR = "Parasols";
  ombrelloniLabel_NL = "Parasols";
  ombrelloniLabel_DE = "Sonnenschirme";

  barLabel_IT = "Servizio Spiaggia";
  barLabel_EN = "Beach Service";
  barLabel_FR = "Service de plage";
  barLabel_NL = "Strandservice";
  barLabel_DE = "Strandservice";

  caricamentoInCorsoLabel_IT = "Caricamento in corso...";
  caricamentoInCorsoLabel_EN = "Loading...";
  caricamentoInCorsoLabel_FR = "Chargement en cours...";
  caricamentoInCorsoLabel_NL = "Laden...";
  caricamentoInCorsoLabel_DE = "Laden...";

  stiamRecuperandoOrdiniLabel_IT = "Stiamo recuperando i tuoi ordini";
  stiamRecuperandoOrdiniLabel_EN = "We are retrieving your orders";
  stiamRecuperandoOrdiniLabel_FR = "Nous récupérons vos commandes";
  stiamRecuperandoOrdiniLabel_NL = "We halen uw bestellingen op";
  stiamRecuperandoOrdiniLabel_DE = "Wir laden Ihre Bestellungen";

  nessunOrdinePresenteLabel_IT = "Nessun ordine presente";
  nessunOrdinePresenteLabel_EN = "No orders present";
  nessunOrdinePresenteLabel_FR = "Aucune commande présente";
  nessunOrdinePresenteLabel_NL = "Geen bestellingen aanwezig";
  nessunOrdinePresenteLabel_DE = "Keine Bestellungen vorhanden";

  scorriPerAggiornareLabel_IT = "Scorri per aggiornare";
  scorriPerAggiornareLabel_EN = "Pull to refresh";
  scorriPerAggiornareLabel_FR = "Tirer pour actualiser";
  scorriPerAggiornareLabel_NL = "Trek om te vernieuwen";
  scorriPerAggiornareLabel_DE = "Zum Aktualisieren ziehen";

  aggiornamentoLabel_IT = "Aggiornamento...";
  aggiornamentoLabel_EN = "Refreshing...";
  aggiornamentoLabel_FR = "Actualisation...";
  aggiornamentoLabel_NL = "Vernieuwen...";
  aggiornamentoLabel_DE = "Aktualisieren...";

  legendaCapienzaLabel_IT = "Legenda Capienza";
  legendaCapienzaLabel_EN = "Capacity Legend";
  legendaCapienzaLabel_FR = "Légende de capacité";
  legendaCapienzaLabel_NL = "Capaciteitslegende";
  legendaCapienzaLabel_DE = "Kapazitätslegende";

  personeLabel_IT = "Persone";
  personeLabel_EN = "People";
  personeLabel_FR = "Personnes";
  personeLabel_NL = "Personen";
  personeLabel_DE = "Personen";

  caniGrandiLabel_IT = "Cani Grandi";
  caniGrandiLabel_EN = "Large Dogs";
  caniGrandiLabel_FR = "Grands chiens";
  caniGrandiLabel_NL = "Grote honden";
  caniGrandiLabel_DE = "Große Hunde";

  caniPiccoliLabel_IT = "Cani Piccoli";
  caniPiccoliLabel_EN = "Small Dogs";
  caniPiccoliLabel_FR = "Petits chiens";
  caniPiccoliLabel_NL = "Kleine honden";
  caniPiccoliLabel_DE = "Kleine Hunde";

  caniTotaliLabel_IT = "Cani Totali";
  caniTotaliLabel_EN = "Total Dogs";
  caniTotaliLabel_FR = "Chiens totaux";
  caniTotaliLabel_NL = "Totaal honden";
  caniTotaliLabel_DE = "Hunde gesamt";

  totLabel_IT = "Tot:";
  totLabel_EN = "Tot:";
  totLabel_FR = "Tot:";
  totLabel_NL = "Tot:";
  totLabel_DE = "Ges:";
  /* Fine Ricerca Ombrellone */

  /* Search Ombrellone Component */
  quantePersoneLabel_IT = "Persone";
  quantePersoneLabel_EN = "People";
  quantePersoneLabel_FR = "Personnes";
  quantePersoneLabel_NL = "Personen";
  quantePersoneLabel_DE = "Personen";

  quantiCaniLabel_IT = "Cani";
  quantiCaniLabel_EN = "Dogs";
  quantiCaniLabel_FR = "Chiens";
  quantiCaniLabel_NL = "Honden";
  quantiCaniLabel_DE = "Hunde";

  nessunCaneOptionLabel_IT = "0 cani / nessun cane";
  nessunCaneOptionLabel_EN = "0 dogs / no dog";
  nessunCaneOptionLabel_FR = "0 chiens / aucun chien";
  nessunCaneOptionLabel_NL = "0 honden / geen hond";
  nessunCaneOptionLabel_DE = "0 Hunde / kein Hund";

  selezionaNumeroCaniLabel_IT = "Seleziona numero cani (anche 0)";
  selezionaNumeroCaniLabel_EN = "Select number of dogs (including 0)";
  selezionaNumeroCaniLabel_FR = "Sélectionnez le nombre de chiens (même 0)";
  selezionaNumeroCaniLabel_NL = "Selecteer aantal honden (ook 0)";
  selezionaNumeroCaniLabel_DE = "Anzahl Hunde wählen (auch 0)";

  dogSelectionWarningLabel_IT = "Per continuare e necessario scegliere il numero di cani e la relativa taglia.";
  dogSelectionWarningLabel_EN = "To continue, you need to choose the number of dogs and their size.";
  dogSelectionWarningLabel_FR = "Pour continuer, vous devez choisir le nombre de chiens et leur taille.";
  dogSelectionWarningLabel_NL = "Om verder te gaan, moet je het aantal honden en hun grootte kiezen.";
  dogSelectionWarningLabel_DE = "Um fortzufahren, muessen Sie die Anzahl der Hunde und ihre Groesse auswaehlen.";

  piccolaLabel_IT = "Piccola (≤ 14 kg)";
  piccolaLabel_EN = "Small (≤ 14 kg)";
  piccolaLabel_FR = "Petite (≤ 14 kg)";
  piccolaLabel_NL = "Klein (≤ 14 kg)";
  piccolaLabel_DE = "Klein (≤ 14 kg)";

  grandeLabel_IT = "Grande (> 14 kg)";
  grandeLabel_EN = "Large (> 14 kg)";
  grandeLabel_FR = "Grande (> 14 kg)";
  grandeLabel_NL = "Groot (> 14 kg)";
  grandeLabel_DE = "Groß (> 14 kg)";
  /* Fine Search Ombrellone Component */

  /* Main Page */
  menuLabel_IT = "Menu";
  menuLabel_EN = "Menu";
  menuLabel_FR = "Menu";
  menuLabel_NL = "Menu";
  menuLabel_DE = "Menü";

  disabilitySidebarLabel_IT = "Accessibilita Disabili";
  disabilitySidebarLabel_EN = "Disability Access";
  disabilitySidebarLabel_FR = "Accessibilite PMR";
  disabilitySidebarLabel_NL = "Toegang mindervaliden";
  disabilitySidebarLabel_DE = "Barrierefreiheit";

  pregnancySidebarLabel_IT = "Donne in Gravidanza";
  pregnancySidebarLabel_EN = "Pregnancy Info";
  pregnancySidebarLabel_FR = "Femmes enceintes";
  pregnancySidebarLabel_NL = "Zwangerschap";
  pregnancySidebarLabel_DE = "Schwangerschaft";

  disabilityInfoTitle_IT = "Sezione Disabili";
  disabilityInfoTitle_EN = "Disability Information";
  disabilityInfoTitle_FR = "Section Handicap";
  disabilityInfoTitle_NL = "Informatie mindervaliden";
  disabilityInfoTitle_DE = "Informationen fur Menschen mit Behinderung";

  disabilityInfoIntro_IT = "Lo stabilimento e completamente accessibile a persone con disabilita motoria.";
  disabilityInfoIntro_EN = "The facility is fully accessible to people with reduced mobility.";
  disabilityInfoIntro_FR = "L'etablissement est entierement accessible aux personnes a mobilite reduite.";
  disabilityInfoIntro_NL = "De strandlocatie is volledig toegankelijk voor mensen met beperkte mobiliteit.";
  disabilityInfoIntro_DE = "Die Anlage ist vollstandig fur Menschen mit eingeschrankter Mobilitat zuganglich.";

  disabilityInfoWalkwaysLead_IT = "Le passerelle collegano:";
  disabilityInfoWalkwaysLead_EN = "Walkways connect:";
  disabilityInfoWalkwaysLead_FR = "Les passerelles relient :";
  disabilityInfoWalkwaysLead_NL = "Loopbruggen verbinden:";
  disabilityInfoWalkwaysLead_DE = "Stege verbinden:";

  disabilityInfoRestaurant_IT = "ristorante";
  disabilityInfoRestaurant_EN = "restaurant";
  disabilityInfoRestaurant_FR = "restaurant";
  disabilityInfoRestaurant_NL = "restaurant";
  disabilityInfoRestaurant_DE = "Restaurant";

  disabilityInfoToilets_IT = "servizi igienici";
  disabilityInfoToilets_EN = "restrooms";
  disabilityInfoToilets_FR = "toilettes";
  disabilityInfoToilets_NL = "sanitaire voorzieningen";
  disabilityInfoToilets_DE = "Sanitarbereiche";

  disabilityInfoBeachSpots_IT = "tutte le postazioni spiaggia.";
  disabilityInfoBeachSpots_EN = "all beach stations.";
  disabilityInfoBeachSpots_FR = "toutes les zones de plage.";
  disabilityInfoBeachSpots_NL = "alle strandplaatsen.";
  disabilityInfoBeachSpots_DE = "alle Strandplatze.";

  disabilityInfoGazeboSuggestion_IT = "Le postazioni piu indicate sono i Gazebo.";
  disabilityInfoGazeboSuggestion_EN = "The most suitable stations are Gazebos.";
  disabilityInfoGazeboSuggestion_FR = "Les postes les plus adaptes sont les Gazebos.";
  disabilityInfoGazeboSuggestion_NL = "De meest geschikte plaatsen zijn de Gazebos.";
  disabilityInfoGazeboSuggestion_DE = "Die am besten geeigneten Platze sind die Gazebos.";

  disabilityInfoStandardGazeboLabel_IT = "Gazebo consigliati (Standard):";
  disabilityInfoStandardGazeboLabel_EN = "Recommended Gazebos (Standard):";
  disabilityInfoStandardGazeboLabel_FR = "Gazebos recommandes (Standard) :";
  disabilityInfoStandardGazeboLabel_NL = "Aanbevolen Gazebos (Standard):";
  disabilityInfoStandardGazeboLabel_DE = "Empfohlene Gazebos (Standard):";

  disabilityInfoBusinessGazeboLabel_IT = "Gazebo Business Class consigliati:";
  disabilityInfoBusinessGazeboLabel_EN = "Recommended Business Class Gazebos:";
  disabilityInfoBusinessGazeboLabel_FR = "Gazebos Business Class recommandes :";
  disabilityInfoBusinessGazeboLabel_NL = "Aanbevolen Business Class Gazebos:";
  disabilityInfoBusinessGazeboLabel_DE = "Empfohlene Business-Class-Gazebos:";

  pregnancyInfoTitle_IT = "Sezione Donne in Gravidanza";
  pregnancyInfoTitle_EN = "Pregnancy Information";
  pregnancyInfoTitle_FR = "Section Femmes enceintes";
  pregnancyInfoTitle_NL = "Informatie Zwangerschap";
  pregnancyInfoTitle_DE = "Informationen Schwangerschaft";

  pregnancyInfoIntro_IT = "Per le donne in gravidanza si consiglia la prenotazione di un Gazebo.";
  pregnancyInfoIntro_EN = "For pregnant women, booking a Gazebo is recommended.";
  pregnancyInfoIntro_FR = "Pour les femmes enceintes, la reservation d'un Gazebo est conseillee.";
  pregnancyInfoIntro_NL = "Voor zwangere vrouwen wordt het boeken van een Gazebo aangeraden.";
  pregnancyInfoIntro_DE = "Fur schwangere Frauen wird die Buchung eines Gazebos empfohlen.";

  pregnancyInfoAdvantagesLead_IT = "Il Gazebo offre:";
  pregnancyInfoAdvantagesLead_EN = "A Gazebo offers:";
  pregnancyInfoAdvantagesLead_FR = "Le Gazebo offre :";
  pregnancyInfoAdvantagesLead_NL = "Een Gazebo biedt:";
  pregnancyInfoAdvantagesLead_DE = "Ein Gazebo bietet:";

  pregnancyInfoAdvantageShade_IT = "maggiore ombreggiatura";
  pregnancyInfoAdvantageShade_EN = "more shade";
  pregnancyInfoAdvantageShade_FR = "plus d'ombre";
  pregnancyInfoAdvantageShade_NL = "meer schaduw";
  pregnancyInfoAdvantageShade_DE = "mehr Schatten";

  pregnancyInfoAdvantageSpace_IT = "maggiore spazio";
  pregnancyInfoAdvantageSpace_EN = "more space";
  pregnancyInfoAdvantageSpace_FR = "plus d'espace";
  pregnancyInfoAdvantageSpace_NL = "meer ruimte";
  pregnancyInfoAdvantageSpace_DE = "mehr Platz";

  pregnancyInfoAdvantageSeats_IT = "diverse tipologie di sedute, inclusa la sedia regista.";
  pregnancyInfoAdvantageSeats_EN = "different seating options, including the director's chair.";
  pregnancyInfoAdvantageSeats_FR = "differentes options d'assise, y compris la chaise metteur en scene.";
  pregnancyInfoAdvantageSeats_NL = "verschillende zitopties, inclusief de regisseursstoel.";
  pregnancyInfoAdvantageSeats_DE = "verschiedene Sitzoptionen, einschliesslich Regiestuhl.";

  pregnancyInfoUmbrellaWarning_IT = "Nel caso di scelta di ombrellone, verificare attentamente le dotazioni incluse, che variano in base alla posizione rispetto al mare.";
  pregnancyInfoUmbrellaWarning_EN = "If you choose an umbrella, carefully check the included equipment, which varies by distance from the sea.";
  pregnancyInfoUmbrellaWarning_FR = "En cas de choix d'un parasol, verifiez attentivement les equipements inclus, qui varient selon la position par rapport a la mer.";
  pregnancyInfoUmbrellaWarning_NL = "Als je voor een parasol kiest, controleer dan goed de inbegrepen voorzieningen, die verschillen per afstand tot de zee.";
  pregnancyInfoUmbrellaWarning_DE = "Bei Wahl eines Sonnenschirms prufen Sie bitte sorgfaltig die enthaltene Ausstattung, die je nach Lage zum Meer variiert.";

  pregnancyInfoNoSeatReplacement_IT = "Non è consentita la sostituzione delle sedute incluse nella postazione prenotata.";
  pregnancyInfoNoSeatReplacement_EN = "Replacing the seats included in the booked station is not allowed.";
  pregnancyInfoNoSeatReplacement_FR = "Le remplacement des assises incluses dans le poste reserve n'est pas autorise.";
  pregnancyInfoNoSeatReplacement_NL = "Het vervangen van de inbegrepen zitplaatsen in de geboekte plek is niet toegestaan.";
  pregnancyInfoNoSeatReplacement_DE = "Ein Austausch der in der gebuchten Station enthaltenen Sitzplatze ist nicht gestattet.";
  /* Fine Main Page */

  /* Carrello Labels (some already exist, adding missing ones) */
  dalLabel_IT = "Dal";
  dalLabel_EN = "From";
  dalLabel_FR = "Du";
  dalLabel_NL = "Van";
  dalLabel_DE = "Von";

  alLabel_IT = "Al";
  alLabel_EN = "To";
  alLabel_FR = "Au";
  alLabel_NL = "Tot";
  alLabel_DE = "Bis";

  fasciaLabel_IT = "Fascia";
  fasciaLabel_EN = "Time Slot";
  fasciaLabel_FR = "Créneau";
  fasciaLabel_NL = "Tijdslot";
  fasciaLabel_DE = "Zeitfenster";

  serviziLabel_IT = "Servizi";
  serviziLabel_EN = "Services";
  serviziLabel_FR = "Services";
  serviziLabel_NL = "Diensten";
  serviziLabel_DE = "Leistungen";

  extraLabel_IT = "Extra";
  extraLabel_EN = "Extra";
  extraLabel_FR = "Extra";
  extraLabel_NL = "Extra";
  extraLabel_DE = "Extra";

  /* Generic UI Labels */
  testModeLabel_IT = "MODALITA TEST";
  testModeLabel_EN = "TEST MODE";
  testModeLabel_FR = "MODE TEST";
  testModeLabel_NL = "TESTMODUS";
  testModeLabel_DE = "TESTMODUS";

  languageSelectorLabel_IT = "Lingua / Language";
  languageSelectorLabel_EN = "Language";
  languageSelectorLabel_FR = "Langue";
  languageSelectorLabel_NL = "Taal";
  languageSelectorLabel_DE = "Sprache";

  homeLabel_IT = "Home";
  homeLabel_EN = "Home";
  homeLabel_FR = "Accueil";
  homeLabel_NL = "Home";
  homeLabel_DE = "Home";

  loginLabel_IT = "Login";
  loginLabel_EN = "Login";
  loginLabel_FR = "Connexion";
  loginLabel_NL = "Login";
  loginLabel_DE = "Anmelden";

  logoutLabel_IT = "Logout";
  logoutLabel_EN = "Logout";
  logoutLabel_FR = "Deconnexion";
  logoutLabel_NL = "Uitloggen";
  logoutLabel_DE = "Abmelden";

  whatsAppIconLabel_IT = "Assistenza WhatsApp";
  whatsAppIconLabel_EN = "WhatsApp support";
  whatsAppIconLabel_FR = "Assistance WhatsApp";
  whatsAppIconLabel_NL = "WhatsApp ondersteuning";
  whatsAppIconLabel_DE = "WhatsApp-Support";

  whatsAppModalHeaderLabel_IT = "Scrivici su WhatsApp";
  whatsAppModalHeaderLabel_EN = "Write to us on WhatsApp";
  whatsAppModalHeaderLabel_FR = "Ecrivez-nous sur WhatsApp";
  whatsAppModalHeaderLabel_NL = "Schrijf ons op WhatsApp";
  whatsAppModalHeaderLabel_DE = "Schreiben Sie uns auf WhatsApp";

  whatsAppModalMessageLabel_IT = "Inserisci il tuo messaggio";
  whatsAppModalMessageLabel_EN = "Enter your message";
  whatsAppModalMessageLabel_FR = "Entrez votre message";
  whatsAppModalMessageLabel_NL = "Voer je bericht in";
  whatsAppModalMessageLabel_DE = "Nachricht eingeben";

  whatsAppModalPlaceholderLabel_IT = "Digita qui...";
  whatsAppModalPlaceholderLabel_EN = "Type here...";
  whatsAppModalPlaceholderLabel_FR = "Ecrivez ici...";
  whatsAppModalPlaceholderLabel_NL = "Typ hier...";
  whatsAppModalPlaceholderLabel_DE = "Hier schreiben...";

  whatsAppSendLabel_IT = "Invia";
  whatsAppSendLabel_EN = "Send";
  whatsAppSendLabel_FR = "Envoyer";
  whatsAppSendLabel_NL = "Versturen";
  whatsAppSendLabel_DE = "Senden";

  whatsAppEmptyMessageLabel_IT = "Inserisci un messaggio prima di continuare.";
  whatsAppEmptyMessageLabel_EN = "Please enter a message before continuing.";
  whatsAppEmptyMessageLabel_FR = "Veuillez saisir un message avant de continuer.";
  whatsAppEmptyMessageLabel_NL = "Voer een bericht in voordat je doorgaat.";
  whatsAppEmptyMessageLabel_DE = "Bitte geben Sie eine Nachricht ein, bevor Sie fortfahren.";

  whatsAppMissingNumberLabel_IT = "Numero WhatsApp non configurato.";
  whatsAppMissingNumberLabel_EN = "WhatsApp number is not configured.";
  whatsAppMissingNumberLabel_FR = "Le numero WhatsApp n'est pas configure.";
  whatsAppMissingNumberLabel_NL = "WhatsApp-nummer is niet geconfigureerd.";
  whatsAppMissingNumberLabel_DE = "WhatsApp-Nummer ist nicht konfiguriert.";

  logoutAlertHeader_IT = "Conferma logout";
  logoutAlertHeader_EN = "Confirm logout";
  logoutAlertHeader_FR = "Confirmer la deconnexion";
  logoutAlertHeader_NL = "Uitloggen bevestigen";
  logoutAlertHeader_DE = "Logout bestätigen";

  logoutAlertMessage_IT = "Sei sicuro di voler effettuare il logout?";
  logoutAlertMessage_EN = "Are you sure you want to log out?";
  logoutAlertMessage_FR = "Etes-vous sur de vouloir vous deconnecter ?";
  logoutAlertMessage_NL = "Weet je zeker dat je wilt uitloggen?";
  logoutAlertMessage_DE = "Möchten Sie sich wirklich abmelden?";

  emailLabel_IT = "Email";
  emailLabel_EN = "Email";
  emailLabel_FR = "Email";
  emailLabel_NL = "E-mail";
  emailLabel_DE = "E-Mail";

  passwordLabel_IT = "Password";
  passwordLabel_EN = "Password";
  passwordLabel_FR = "Mot de passe";
  passwordLabel_NL = "Wachtwoord";
  passwordLabel_DE = "Passwort";

  noteLabel_IT = "Note";
  noteLabel_EN = "Notes";
  noteLabel_FR = "Notes";
  noteLabel_NL = "Notities";
  noteLabel_DE = "Hinweise";

  newsEventiLabel_IT = "NEWS & EVENTI";
  newsEventiLabel_EN = "NEWS & EVENTS";
  newsEventiLabel_FR = "ACTUALITES & EVENEMENTS";
  newsEventiLabel_NL = "NIEUWS & EVENEMENTEN";
  newsEventiLabel_DE = "NEWS & EVENTS";

  socialNetworksLabel_IT = "SOCIAL NETWORKS";
  socialNetworksLabel_EN = "SOCIAL NETWORKS";
  socialNetworksLabel_FR = "RESEAUX SOCIAUX";
  socialNetworksLabel_NL = "SOCIALE NETWERKEN";
  socialNetworksLabel_DE = "SOZIALE NETZWERKE";

  facebookLabel_IT = "Facebook";
  facebookLabel_EN = "Facebook";
  facebookLabel_FR = "Facebook";
  facebookLabel_NL = "Facebook";
  facebookLabel_DE = "Facebook";

  instagramLabel_IT = "Instagram";
  instagramLabel_EN = "Instagram";
  instagramLabel_FR = "Instagram";
  instagramLabel_NL = "Instagram";
  instagramLabel_DE = "Instagram";

  retryLabel_IT = "Riprova";
  retryLabel_EN = "Retry";
  retryLabel_FR = "Reessayer";
  retryLabel_NL = "Opnieuw proberen";
  retryLabel_DE = "Erneut versuchen";

  eliminaPrenotazioneTitleLabel_IT = "ELIMINA PRENOTAZIONE";
  eliminaPrenotazioneTitleLabel_EN = "DELETE BOOKING";
  eliminaPrenotazioneTitleLabel_FR = "SUPPRIMER LA RESERVATION";
  eliminaPrenotazioneTitleLabel_NL = "BOEKING VERWIJDEREN";
  eliminaPrenotazioneTitleLabel_DE = "BUCHUNG LÖSCHEN";

  barSpiaggiaDisclaimerLabel_IT = "Gli ordini del Servizio Spiaggia sono validi solo per il giorno corrente. Errori nella selezione dei prodotti, delle quantità o eventuali ordini duplicati non danno diritto a rimborso se l'ordine è stato preso in carico o preparato.";
  barSpiaggiaDisclaimerLabel_EN = "Beach Service orders are valid only for the current day. Errors in product selection, quantities, or duplicate orders do not entitle to a refund if the order has been taken in charge or prepared.";
  barSpiaggiaDisclaimerLabel_FR = "Les commandes du Service Plage sont valables uniquement pour le jour en cours. Les erreurs dans la sélection des produits, des quantités ou les éventuelles commandes dupliquées ne donnent pas droit à un remboursement si la commande a été prise en charge ou préparée.";
  barSpiaggiaDisclaimerLabel_NL = "Strandservice-bestellingen zijn alleen geldig voor de huidige dag. Fouten in de productselectie, hoeveelheden of eventuele dubbele bestellingen geven geen recht op terugbetaling als de bestelling in behandeling is genomen of bereid is.";
  barSpiaggiaDisclaimerLabel_DE = "Strandservice-Bestellungen gelten nur für den aktuellen Tag. Fehler bei der Produktauswahl, den Mengen oder eventuelle Doppelbestellungen geben keinen Anspruch auf Erstattung, wenn die Bestellung bereits angenommen oder zubereitet wurde.";

  eliminaPrenotazioneMessageLabel_IT = "Sei sicuro di voler eliminare la prenotazione?";
  eliminaPrenotazioneMessageLabel_EN = "Are you sure you want to delete this booking?";
  eliminaPrenotazioneMessageLabel_FR = "Etes-vous sur de vouloir supprimer cette reservation ?";
  eliminaPrenotazioneMessageLabel_NL = "Weet je zeker dat je deze boeking wilt verwijderen?";
  eliminaPrenotazioneMessageLabel_DE = "Möchten Sie diese Buchung wirklich löschen?";

  irreversibleActionLabel_IT = "Questa azione è irreversibile";
  irreversibleActionLabel_EN = "This action is irreversible";
  irreversibleActionLabel_FR = "Cette action est irreversible";
  irreversibleActionLabel_NL = "Deze actie is onomkeerbaar";
  irreversibleActionLabel_DE = "Diese Aktion ist irreversibel";

  eliminaAccountTitleLabel_IT = "ELIMINA ACCOUNT";
  eliminaAccountTitleLabel_EN = "DELETE ACCOUNT";
  eliminaAccountTitleLabel_FR = "SUPPRIMER LE COMPTE";
  eliminaAccountTitleLabel_NL = "ACCOUNT VERWIJDEREN";
  eliminaAccountTitleLabel_DE = "KONTO LÖSCHEN";

  eliminaAccountMessageLabel_IT = "Sei sicuro di voler eliminare il tuo account?";
  eliminaAccountMessageLabel_EN = "Are you sure you want to delete your account?";
  eliminaAccountMessageLabel_FR = "Etes-vous sur de vouloir supprimer votre compte ?";
  eliminaAccountMessageLabel_NL = "Weet je zeker dat je je account wilt verwijderen?";
  eliminaAccountMessageLabel_DE = "Möchten Sie Ihr Konto wirklich löschen?";

  privacyPolicyItalianLabel_IT = "Privacy Policy - Italiano";
  privacyPolicyItalianLabel_EN = "Privacy Policy - Italian";
  privacyPolicyItalianLabel_FR = "Privacy Policy - Italien";
  privacyPolicyItalianLabel_NL = "Privacybeleid - Italiaans";
  privacyPolicyItalianLabel_DE = "Datenschutzerklärung - Italienisch";

  privacyPolicyEnglishLabel_IT = "Privacy Policy - Inglese";
  privacyPolicyEnglishLabel_EN = "Privacy Policy - English";
  privacyPolicyEnglishLabel_FR = "Privacy Policy - Anglais";
  privacyPolicyEnglishLabel_NL = "Privacybeleid - Engels";
  privacyPolicyEnglishLabel_DE = "Datenschutzerklärung - Englisch";

  stripeLabel_IT = "STRIPE";
  stripeLabel_EN = "STRIPE";
  stripeLabel_FR = "STRIPE";
  stripeLabel_NL = "STRIPE";
  stripeLabel_DE = "STRIPE";

  paypalLabel_IT = "PAYPAL";
  paypalLabel_EN = "PAYPAL";
  paypalLabel_FR = "PAYPAL";
  paypalLabel_NL = "PAYPAL";
  paypalLabel_DE = "PAYPAL";

  condizioniVenditaTitleLabel_IT = "Condizioni di Vendita";
  condizioniVenditaTitleLabel_EN = "Terms of Sale";
  condizioniVenditaTitleLabel_FR = "Conditions de Vente";
  condizioniVenditaTitleLabel_NL = "Verkoopvoorwaarden";
  condizioniVenditaTitleLabel_DE = "Verkaufsbedingungen";

  condizioniVenditaReadCtaLabel_IT = "Confermo di aver letto tutto il documento";
  condizioniVenditaReadCtaLabel_EN = "I confirm I have read the full document";
  condizioniVenditaReadCtaLabel_FR = "Je confirme avoir lu l'integralite du document";
  condizioniVenditaReadCtaLabel_NL = "Ik bevestig dat ik het volledige document heb gelezen";
  condizioniVenditaReadCtaLabel_DE = "Ich bestätige, dass ich das vollständige Dokument gelesen habe";

  condizioniVenditaReadHintLabel_IT = "Leggi le condizioni di vendita e conferma nella modale per abilitare la checkbox.";
  condizioniVenditaReadHintLabel_EN = "Read the terms in the modal and confirm to enable the checkbox.";
  condizioniVenditaReadHintLabel_FR = "Lisez les conditions dans la fenetre modale et confirmez pour activer la case.";
  condizioniVenditaReadHintLabel_NL = "Lees de voorwaarden in de modal en bevestig om het selectievakje te activeren.";
  condizioniVenditaReadHintLabel_DE = "Lesen Sie die Bedingungen im Modal und bestätigen Sie, um das Kontrollkästchen zu aktivieren.";

  condizioniVenditaReadDoneLabel_IT = "Lettura confermata";
  condizioniVenditaReadDoneLabel_EN = "Reading confirmed";
  condizioniVenditaReadDoneLabel_FR = "Lecture confirmee";
  condizioniVenditaReadDoneLabel_NL = "Lezen bevestigd";
  condizioniVenditaReadDoneLabel_DE = "Lesen bestätigt";

  numeroOrdineBreveLabel_IT = "Ord. Nr";
  numeroOrdineBreveLabel_EN = "Order Nr";
  numeroOrdineBreveLabel_FR = "Cmd. Nr";
  numeroOrdineBreveLabel_NL = "Best. Nr";
  numeroOrdineBreveLabel_DE = "Bestellnr.";

  statoLabel_IT = "Stato";
  statoLabel_EN = "Status";
  statoLabel_FR = "Statut";
  statoLabel_NL = "Status";
  statoLabel_DE = "Status";

  articoliLabel_IT = "Articoli";
  articoliLabel_EN = "Items";
  articoliLabel_FR = "Articles";
  articoliLabel_NL = "Artikelen";
  articoliLabel_DE = "Artikel";

  statoNonProntoLabel_IT = "NON PRONTO";
  statoNonProntoLabel_EN = "NOT READY";
  statoNonProntoLabel_FR = "PAS PRET";
  statoNonProntoLabel_NL = "NIET KLAAR";
  statoNonProntoLabel_DE = "NICHT BEREIT";

  statoInGestioneLabel_IT = "IN GESTIONE";
  statoInGestioneLabel_EN = "IN PROGRESS";
  statoInGestioneLabel_FR = "EN COURS";
  statoInGestioneLabel_NL = "IN BEHANDELING";
  statoInGestioneLabel_DE = "IN BEARBEITUNG";

  statoProntoLabel_IT = "PRONTO";
  statoProntoLabel_EN = "READY";
  statoProntoLabel_FR = "PRET";
  statoProntoLabel_NL = "KLAAR";
  statoProntoLabel_DE = "BEREIT";

  onlineLabel_IT = "ONLINE";
  onlineLabel_EN = "ONLINE";
  onlineLabel_FR = "EN LIGNE";
  onlineLabel_NL = "ONLINE";
  onlineLabel_DE = "ONLINE";

  /* Fine Carrello */

  constructor(private storage: StorageService, private injector: Injector) {
    this.storage.get('locale_lang').then((val) => {
      // console.log("sono dentro lang" + val);
      //  console.log("Stato Token Dentro App Component: " + val);
      if (val != undefined && val != null && val != '') {
        const normalizedLang = `${val}`.toUpperCase();
        this.languageSelected = normalizedLang;
        if (normalizedLang !== val) {
          this.storage.set('locale_lang', normalizedLang);
        }
        this.controllaFlag();
      }
      else {
        this.storage.set('locale_lang', 'IT').then((val) => {
          this.languageSelected = 'IT';
          this.controllaFlag();
        });
      }
    });
  }

  controllaFlag() {
    if (this.languageSelected == 'EN' || this.languageSelected == 'en' || this.languageSelected == 'En') {
      this.flagLanguageSelected = 'En';
    } else if (this.languageSelected == 'IT' || this.languageSelected == 'it' || this.languageSelected == 'It') {
      this.flagLanguageSelected = 'It';
    } else if (this.languageSelected == 'FR' || this.languageSelected == 'fr' || this.languageSelected == 'Fr') {
      this.flagLanguageSelected = 'Fr';
    } else if (this.languageSelected == 'NL' || this.languageSelected == 'nl' || this.languageSelected == 'Nl') {
      this.flagLanguageSelected = 'Nl';
    } else if (this.languageSelected == 'DE' || this.languageSelected == 'de' || this.languageSelected == 'De') {
      this.flagLanguageSelected = 'De';
    }
  }

  /**
   * Applica la lingua ricevuta dal server al login, sovrascrivendo il localStorage.
   * Non esegue reload: la navigazione successiva applicherà la lingua.
   */
  async applyLanguageFromServer(lingua: string): Promise<void> {
    if (!lingua) return;
    const lang = lingua.toUpperCase();
    await this.storage.set('locale_lang', lang);
    this.languageSelected = lang;
    this.controllaFlag();
  }

  /**
   * Metodo centralizzato per cambiare la lingua dell'applicazione
   * @param lingua - Codice della lingua (IT, EN, FR, NL, DE)
   */
  chooseLanguage(lingua: string): void {
    const linguaScelta = lingua + "";
    const linguaUppercase = linguaScelta.toUpperCase();

    this.storage.set('locale_lang', linguaUppercase).then(() => {
      this.languageSelected = linguaUppercase;
      this.controllaFlag();

      // Salva la lingua sul backend (se loggato), poi reload
      this.salvataLinguaSuBackend(linguaUppercase).then(() => {
        window.location.reload();
      });
    });
  }

  /**
   * Salva la lingua selezionata sul backend se l'utente è loggato.
   * Usa Injector per evitare dipendenza circolare con SomeProvider.
   * Restituisce una Promise che si risolve a operazione completata (o subito se non loggato).
   */
  private async salvataLinguaSuBackend(lingua: string): Promise<void> {
    const token = await this.storage.get('token');
    if (!token) return;

    // Import dinamico per evitare dipendenza circolare con SomeProvider
    const { SomeProvider } = await import('../some/some');
    const { HttprequestService } = await import('../httprequest.service');
    const myService = this.injector.get(SomeProvider, null);
    const http = this.injector.get(HttprequestService, null);

    if (!myService || !http || !myService.datiUtente?.idUtente) return;

    const postData = {
      nome: myService.datiUtente.nome,
      idUtente: myService.datiUtente.idUtente,
      cognome: myService.datiUtente.cognome,
      telefono: myService.datiUtente.telefono,
      image: myService.datiUtente.fotoProfilo,
      lingua: lingua
    };

    return new Promise<void>((resolve) => {
      http.doPostApplicationJsonBearer(
        myService.apiUrl + myService.serviziRest.updateUtenteAndPassword,
        postData
      ).subscribe({
        next: () => {
          console.log('[LangProvider] Lingua aggiornata sul backend:', lingua);
          resolve();
        },
        error: (err: any) => {
          console.error('[LangProvider] Errore aggiornamento lingua sul backend:', err?.status, err);
          resolve(); // Reload comunque anche in caso di errore
        }
      });
    });
  }

}
